export default class SqzlPersonalization {
     g = null;

    /**
     *
     * @type {Window} Window object
     * @private
     */
    _window = null;

    /**
     * @type {Document} Document object of your window
     * @private
     */
    _document = null;

    /**
     * @type {Object} Local storage of your window
     * @private
     */
    _localStorage = null;

    /**
     *
     * @type {Object}
     * @private
     */
    _queueItems = null;

    /**
     * @type {Environment}
     */
    _njkEnv = null;

    /**
     *
     * @type {String}
     * @private
     */
    _baseUrl = null;

    /**
     *
     * @type {String}
     * @private
     */
    _dynamicBaseUrl = null;

    /**
     *
     * @type {String}
     * @private
     */
    _assetBaseUrl = null;

    /**
     * @type {Object}
     * @private
     */
    _preCompiled = {};

    _flatpickr = null;

    /**
     * @type {{
     *     overlayShown: Boolean,
     *     overlayOpen: Boolean,
     * }}
     * @private
     */
    state = {
        overlayShown: false,
        overlayOpen: false
    };

    sqzlTestMode = typeof sqzlUnitTest !== 'undefined';

    /**
     * @type {{
     *     merchantIdentifier: String,
     *     merchantId: Number,
     *     urlPreviewParam: String,
     *     urlSelectorParam: String,
     *     pathPersonalizationSettings: String,
     *     pathPreview String,
     *     mainCookieName: String,
     *     viewCountCookieName: String,
     *     viewCountCookieOldName: String,
     *     disablePersonalizationCookieName: String,
     *     sqzlContainerId: String,
     *     initTime: Number,
     *     triggeredPersonalizations: Object,
     *     viewCookieExpirationDays: Number,
     *     defaultFrequencyCapDays: Number,
     *     closingModalExpirationDays: Number,
     *     initialized: boolean,
     *     personalizationTriggerOnProductEventsFound: [],
     *     isTravel: boolean,
     *     noProductFoundAfterWaiting: boolean // timer finished and no product found, normal personalizations are triggered,
     *     merchantLocale: ?String,
     *     lastEventLanguage: ?String,
     *     htmlLanguage: ?String,
     * }}
     * @private
     */
    _settings = {
        merchantIdentifier: '',
        merchantId: 0,
        urlPreviewParam: '_sqzlPreview',
        urlSelectorParam: '_sqzlSelector',
        eventSelectorParam: '_sqzlEventSelector',
        pathPersonalizationSettings: '/p?m=',
        pathPersonalization: '/personalization/',
        pathPreview: '/_pv/v3/',
        sqzlContainerId: 'sqzl_container',
        mainCookieName: 'sqzllocal',
        viewCountCookieName: 'sqzl_vw',
        viewCountCookieOldName: 'sqzl_variant_view_',
        disablePersonalizationCookieName: 'sqzl_disable_personalization_',
        initTime: 0,
        triggeredPersonalizations: {},
        viewCookieExpirationDays: 365,
        defaultFrequencyCapDays: 30,
        closingModalExpirationDays: 7,
        isTravel: false,
        initialized: false,
        personalizationTriggerOnProductEventsFound: [],
        noProductFoundAfterWaiting: false,
        merchantLocale: null,
        lastEventLanguage: null,
        htmlLanguage: null
    };

    /**
     *
     * @type {HTMLDivElement}
     * @private
     */
    _sqzlContainer = null;

    /**
     * An array with personalizations id that loaded on this page
     *
     * @type {*[]}
     * @private
     */
    _loadedPersonalizationIds = [];

    /**
     * Array of personalizations that are queued to be triggered by specific event rules
     *
     * @type {Array}
     * @private
     */
    _personalizationQueuedForEvents = [];

    /**
     * Array with a list of all pixel events seen until now
     *
     * @type {Array}
     * @private
     */
    _handledPixelEvents = [];

    /**
     * Array of personalizations that are queued and triggered after timeout is reached and no product is found
     *
     * @type {Array}
     * @private
     */
    _personalizationQueuedIfNoProductFound = [];

    /**
     *
     * @type {null|Number}
     * @private
     */
    _personalizationQueuedIfNoProductFoundTimer = null;

    /**
     *
     * @type {{}}
     * @private
     */
    _personalizationSettingCloseModalExpirationDays = {};

    /**
     *
     * @type {string|null}
     * @private
     */
    _lastProductEventLanguage = null;

    /**
     *
     * @type {Object|null}
     * @private
     */
    _translationTimeUnits = null;

    /**
     * @typedef {Object} CounterCookie
     * @param {int} CounterCookie.ex - Expiration date, unix timestamp epoch
     * @param {int} CounterCookie.c  counter - Counter value
     */

    /**
     *
     * @type {bool}
     * @private
     */
    _isPushNotificationSupportedBrowser = false;

    /**
     *
     * @type {String}
     * @private
     */
    _notificationPermission = 'default';

    /**
     * Stores the events which triggered a personalization
     *
     * @type {{}}
     * @private
     */
    _triggerEvents = {};

    /**
     * Tells if the document listeners are already done, so on ReloadPersonalization/PageReload we don't attach listeners again
     *
     * @type {boolean}
     * @private
     */
    _documentListenersDone = false;

    constructor() {
        sqzlCommon.g.sqzlPersonalization = this;
        this.g = sqzlCommon.g;

        // @todo Move these to common.js
        this.g._sqzl = this.g._sqzl || [];
        this.g.sqzl = this.g.sqzl || [];
        // Personalization queue
        this.g.sqzl.p = this.g.sqzl.p || [];
        this.g.dataLayer = this.g.dataLayer || [];
    }

    init() {
        if(this._settings.initialized === true) return false;

        this._localStorage = typeof Storage !== 'undefined' ? this.g.localStorage : null;
        this._window = this.g;
        this._document = this.g.document;

        /* @var {Object} [settings={}] settings Additional settings */
        var settings = sqzlCommon.getConfigItem('personalizationSettings', {});

        if(settings.hasOwnProperty('translationTimeUnits')) {
            this._translationTimeUnits = settings.translationTimeUnits;
            delete settings.translationTimeUnits;
        }

        this._settings.initTime = Math.floor(new Date() / 1000);

        this._preCompiled = this._window.nunjucksPrecompiled || {};
        this._baseUrl = settings.baseUrl;
        this._dynamicBaseUrl = settings.dynamicBaseUrl;
        this._assetBaseUrl = settings.assetBaseUrl;

        this._queueItems = this.g.sqzl.p;

        this._settings = Object.assign({}, this._settings, settings);

        if(!this._settings.hasOwnProperty('merchantLocale') || this._settings.merchantLocale === null) {
            this._settings.merchantLocale = sqzlCommon.getConfigItem('merchantLocale');
        }

        // add merchant identifier to personalization path
        this._settings.pathPersonalizationSettings += this._settings.merchantIdentifier;

        var parts = this._settings.merchantIdentifier.match(/SQ-2565([0-9]+)/);

        if(parts) {
            this._settings.merchantId = parts[1];
        }

        this._settings.pathPreview += this._settings.merchantId + '/';

        this._window.nunjucksPrecompiled = this._window.nunjucksPrecompiled || {};
        this._isPushNotificationSupportedBrowser = sqzlCommon.isPushNotificationSupportedBrowser();

        if(!this.sqzlTestMode) {
            this.setNunjucksEnvironment(this.getNunjucksEnvironment());
        }

        this._settings.isTravel = settings.isTravel;

        this._sqzlContainer = this._document.createElement('div');
        this._sqzlContainer.id = this._settings.sqzlContainerId;
        this._sqzlContainer.className = "sqzly-personalization";

        this._document.body.appendChild(this._sqzlContainer);

        // Popup for showing the cookie of the user
        if (this.shouldShowCookie()) {
            this.initializeCookieModal();
            this.showCookieModal();
        }

        if(typeof this._document.documentElement.lang !== 'undefined') {
            // BCP47 format, this can be 2 letter lang code 'en', or locale like structure (en-GB) or even
            // multiple subtags like (en-GB-oxendict). Or single 3 letter country code like 'eng' (but we can't handle these)
            this._settings.htmlLanguage = this._document.documentElement.lang.toLowerCase();
        }

        this.dataLayerWatcher.init();

        var cacheKey = 'initial',
            previewUrlParam = sqzlCommon.getURLParameter(this._settings.urlPreviewParam);
        if(previewUrlParam) {
            if(previewUrlParam.match(/^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i)) {
                // This regex matches UUIDv4 only.
                // First number of third part is the UUID version number.
                // First part of the fourth group is the variant.
                cacheKey = previewUrlParam;
            }

            this.fetchPreview(cacheKey);
        }
        else if(sqzlCommon.getURLParameter(this._settings.urlSelectorParam) || this._window.name === 'sqzly-selector-window') {
            this.enableSelector(cacheKey);
        }
        else {
            if(this._isPushNotificationSupportedBrowser) {
                this._notificationPermission = Notification.permission;
            }

            this._queueItems.push({
                event: 'InitPersonalization',
            });
        }

        this._settings.initialized = true;

        if(sqzlCommon.getConfigItem('instantPushRequest') === true) {
            sqzlCommon.requestPushNotification();
        }
    }

    setNunjucksEnvironment(env) {
        this._njkEnv = env;
    }

    handleDataLayerItem(data) {
        if(typeof data.event !== 'undefined') {
            switch(data.event) {
                case 'QuickPreview':
                    this.enablePreviewCode(function() {
                        this._window.sqzlPersonalizationPreview.init(this._window, this._document);
                        var returnValue = this._window.sqzlPersonalizationPreview.renderPreviewFromCache(data.event, {
                            html: data.data.html,
                            modalSettings: data.data.modalSettings,
                            personalizationSettings: data.data.personalizationSettings,
                            notificationMessages: data.notificationMessages
                        });

                        if(returnValue !== null) {
                            this.insertOrReplaceContainerContent(returnValue.sqzlPersonalization, returnValue.modalSettings);
                            this.addDocumentListeners.call(this);
                            sqzlCommon.initSlider(data.data.modalSettings);
                        }
                    });

                    break;
                case 'InitPersonalization':
                case 'ReloadPersonalization':
                case 'PageReload':
                    // Required for one-page websites, to force reload personalisation if URL changed without page reload
                    if(data.event === 'ReloadPersonalization' || data.event === 'PageReload' ) {
                        this.removePreviousPersonalizations(data);
                    }
                    this.handleInitPersonalization(data.event, data.data);
                    break;
                case 'SetPersonalizations':
                    this.handleSetPersonalizations(data.event, data.data);
                    break;
                case 'PixelEvent':
                    // Wrong use of ReloadPersonalization, triggered as pixel event through the tracker
                    // RePush to personalization queue
                    if(data.eventData.event === 'ReloadPersonalization' || data.eventData.event === 'PageReload') {
                        this.g.sqzl.p.push(data.eventData);
                        break;
                    }

                    this.handlePixelEvent(data.event, data.eventData);
                    break;
                default:
                    // unknown event
                    break;
            }
        }
    }

    dataLayerWatcher = (function (bp) {
        let pushOverwritten = false;

        let init = function() {
            this.overwritePush.call(this);
        };

        let overwritePush = function () {
            if(pushOverwritten === false && typeof bp._queueItems !== 'undefined') {
                if(bp._queueItems.length > 0) {
                    for(let i = 0; i < bp._queueItems.length; i++) {
                        let data = bp._queueItems[i];
                        bp.handleDataLayerItem(data);
                    }
                }
                bp._queueItems.push = customPush;
                pushOverwritten = true;
            }
            else {
                setTimeout(this.overwritePush.bind(this), 250);
            }
        };

        let customPush = function (data) {
            bp.handleDataLayerItem(data);

            return bp._queueItems.length;
        };

        return {init: init, overwritePush: overwritePush};
    })(this);

    /**
     *
     * @param {Number} personalizationId
     * @param {Number} variantId
     * @param {string} variantRevision
     * @param {function} callback
     */
    loadTemplate(personalizationId, variantId, variantRevision, callback) {
        var baseTemplateId = this.getTemplateKey(personalizationId, variantId, variantRevision);

        if(this._window.nunjucksPrecompiled.hasOwnProperty(baseTemplateId)) { // already loaded, execute callback
            callback.bind(this)();
        }
    }

    loadTemplateAndTrigger(personalization, variant, variables) {
        if(variant.settings.hasOwnProperty('original_variant') && variant.settings.original_variant === true) {
            if(['event', 'product'].indexOf(personalization.settings.trigger_type) !== -1) {
                // product/event triggered based personalization, let triggerTemplate handle the event queue
                this.triggerTemplate(personalization, variant, variables);
            }
            //for control group check if any querystring matches
            else if(variant.templateSettings.query_selectors && variant.templateSettings.query_selectors.length > 0) {
                for(var i = 0; i < variant.templateSettings.query_selectors.length; i++) {
                    if(this._document.querySelector(variant.templateSettings.query_selectors[i])) {
                        this.triggerTemplate(personalization, variant, variables);
                        break;
                    }
                }
            }
            else {
                this.triggerTemplate(personalization, variant, variables);
            }
        }
        else if(sqzlCommon.getConfigItem('noJSONP', false) && !sqzlCommon.getDebugLevel()) {
            this.triggerTemplate(personalization, variant, variables);
        }
        else {
            this.loadTemplate(personalization.id, variant.id, variant.settings.revision, function() {
                this.triggerTemplate(personalization, variant, variables)
            });
        }
    }

    getTemplateKey(personalizationId, variantId, variantRevision) {
        return '/_pv/' + personalizationId + '-' + variantId + '-' + variantRevision + '.js'
    }

    /**
     * @param {Object} personalization
     * @param {Object} variant
     * @param {Object} variables
     */
    triggerTemplate(personalization, variant, variables) {
        var divElement = this.renderAndInjectElement(personalization, variables, variant, variant.items);
        if(divElement !== null) {
            if(
                personalization.settings.trigger_type.indexOf('pageload') > -1 &&
                (
                    typeof personalization.settings.trigger_delay === 'undefined' ||
                    (
                        typeof personalization.settings.trigger_delay !== 'undefined' &&
                        personalization.settings.trigger_delay.length === 0
                    )
                )
            ) {
                // Immediately show the content, trigger type is pageload and there are no delays
                this.insertOrReplaceContainerContent(divElement, variables, personalization, variant);
            }

            // @todo Inject a var into basePersonalization containing TriggerTypeEnum's
            if(
                typeof personalization.settings.trigger_delay !== 'undefined' &&
                personalization.settings.trigger_delay.length > 0 &&
                !this.isMultiTriggerPersonalization(personalization)
            ) {
                this.handleDelayTriggers(personalization, divElement, variables, variant);
            }
            else if(['event', 'product'].indexOf(personalization.settings.trigger_type) > -1) {
                this.insertOrReplaceContainerContentByEvent(divElement, variables, personalization, variant);
            }
        }
    }

    handleDelayTriggers(personalization, divElement, variables, variant, initTime) {
        if(personalization.settings.trigger_delay.length === 0){
            return false;
        }

        if(personalization.settings.trigger_delay.indexOf('seconds') > -1 && personalization.settings.trigger_seconds > 0) {
            var currentTime = Math.floor(new Date() / 1000);
            if(typeof initTime === 'undefined') {
                initTime = this._settings.initTime;
            }
            var waitTime = initTime + personalization.settings.trigger_seconds;

            if(waitTime < currentTime) { // already waited more than trigger_seconds, trigger immediately
                this.insertOrReplaceContainerContent(divElement, variables, personalization, variant);
            }
            else {
                var waitBeforeTriggering = (waitTime - currentTime) * 1000;

                setTimeout(function() {
                        this.insertOrReplaceContainerContent(divElement, variables, personalization, variant);
                    }.bind(this),
                    waitBeforeTriggering
                );
            }
        }
        if(personalization.settings.hasOwnProperty('trigger_delay') && personalization.settings.trigger_delay.indexOf('scroll') > -1 && personalization.settings.trigger_scroll > 0) {
            var triggerScrollPixel = this.getBodyHeight() * (personalization.settings.trigger_scroll / 100);

            if(this.getScroll().windowBottom >= triggerScrollPixel) { // Already passed the pixels, trigger immediately
                this.insertOrReplaceContainerContent(divElement, variables, personalization, variant);
            }
            else {
                this._window.addEventListener('scroll', function() {
                    var triggerScrollPixel = this.getBodyHeight() * (personalization.settings.trigger_scroll / 100);

                    if(this.getScroll().windowBottom >= triggerScrollPixel && !this._settings.triggeredPersonalizations.hasOwnProperty(personalization.id)) {
                        this.insertOrReplaceContainerContent(divElement, variables, personalization, variant);
                    }
                }.bind(this));
            }
        }
        if(personalization.settings.hasOwnProperty('trigger_delay') && personalization.settings.trigger_delay.indexOf('exit') > -1) {
            // @TODO Make this a bit more sophisticated
            this._document.body.addEventListener('mouseleave', function(e){
                if(e.clientY <= 2) {
                    this.insertOrReplaceContainerContent(divElement, variables, personalization, variant);
                }
            }.bind(this), false);
        }
    }

    /**
     *
     * @param {String} personalizationId
     * @param {Number|boolean} variantId
     * @param {Number|boolean} variantRevision
     * @param {String=} productSku
     * @return {string}
     */
    getVariantElementId(personalizationId, variantId, variantRevision, productSku) {
        productSku = productSku || '';

        if(!variantId || (!variantRevision && variantRevision !== 0)) { // preview mode has its own personalizationId
            return personalizationId;
        }
        else {
            return 'sqzl_div-' + variantId + '-' + variantRevision + productSku;
        }
    }

    requireScript(_document, url, callback, skipLoadedModule) {
        if(typeof skipLoadedModule !== 'undefined') {
            if(this._window.hasOwnProperty(skipLoadedModule)) {
                callback.bind(this)();
                return;
            }
        }

        var scriptDomElement = _document.createElement('script');
        scriptDomElement.type = 'text/javascript';
        scriptDomElement.src = url;
        scriptDomElement.async = 1;

        if(typeof callback !== 'undefined') {
            if(scriptDomElement.readyState){  //IE
                scriptDomElement.onreadystatechange = function(){
                    if (scriptDomElement.readyState === "loaded" ||
                        scriptDomElement.readyState === "complete") {
                        scriptDomElement.onreadystatechange = null;
                        callback.bind(this)();
                    }
                }.bind(this);
            } else {  //Others
                scriptDomElement.onload = function(){
                    callback.bind(this)();
                }.bind(this);
            }
        }

        _document.head.appendChild(scriptDomElement);

        return scriptDomElement;
    }

    //if there is a viewcontent with a product, don't show this product in personalizations.
    replaceInViewProduct(variant) {

        //only do this if we have a perso with multiple products
        if(variant.items.length > 0 && typeof variant.extra_product !== 'undefined' && variant.extra_product) {
            //see if we got an ViewContent event with 1 product
            this._handledPixelEvents.forEach(function(eventData) {
                if(typeof eventData.event !== 'undefined' && eventData.event === 'ViewContent' && typeof eventData.products !== 'undefined') {
                    //if we see that product in the items, replace it with the extra product
                    for(var i = 0; i < eventData.products.length; i++) {
                        if(typeof eventData.products[i].id !== 'undefined') {
                            for(var j = 0; j < variant.items.length; j++) {
                                if(variant.items[j].product_id === eventData.products[i].id.toString()) {
                                    //variant item same as ViewContent product, update!
                                    variant.items[j] = variant.extra_product;
                                }
                            }
                        }
                    }
                }
            });
        }
        return variant;
    }

    getNunjucksEnvironment(path) {
        path = path || this._baseUrl;

        let env = new sqzlCommon.nunjucks.Environment([
            new sqzlCommon.nunjucks.PrecompiledLoader(this._window.nunjucksPrecompiled),
            new sqzlCommon.nunjucks.WebLoader(path),
        ], {autoescape: false});

        env = this.prepareCustomFilters(env, this._document, this._translationTimeUnits);

        return env;
    }

    /**
     * Tries to get current language in the following priority:
     * - Last language set in events (this is the top-level language property)
     * - Last product language set in events (this is the language property of the product)
     * - Html language if that merchant setting is enabled
     * - Merchant locale
     * - Fallback to 'en-us'
     *
     * @returns {string}
     * Return format: either locale style like 'en-US', 'en-GB' etc. which is {ISO 639-1}-{ISO 3166-1 alpha-2}
     *     or BCP47 format (from html language) which includes loads of different formats e.g, 'en', 'eng', 'en-GB', 'en-GB-oxendict'
     */
    getLanguage() {
        // Fallback
        let foundLanguage = 'en-US';

        if(this._settings.hasOwnProperty('lastEventLanguage') && this._settings.lastEventLanguage !== null && this._settings.lastEventLanguage.length > 0) {
            foundLanguage = this._settings.lastEventLanguage;
        }
        else if(this._lastProductEventLanguage && this._lastProductEventLanguage.length > 0) {
            foundLanguage = this._lastProductEventLanguage;
        }
        // Use html language over merchant locale for merchants with this setting enabled. Necessary for single
        // merchants with multiple languages for personalization call to function properly in all scenarios. (SQZLY-11409)
        else if(this._settings?.useHtmlLanguage === true) {
            if(this._settings?.htmlLanguage !== null && this._settings?.htmlLanguage.length > 0) {
                foundLanguage = this._settings.htmlLanguage;
            }
        }
        else if(this._settings.hasOwnProperty('merchantLocale') && this._settings.merchantLocale !== null && this._settings.merchantLocale.length > 0) {
            foundLanguage = this._settings.merchantLocale;
        }

        return foundLanguage;
    }

    /**
     *
     * @param env
     * @param {Document} _document
     * @param {Object} translationTimeUnits Force overwrite _translationTimeUnits (needed for preview mode)
     * @param {string} [language] Force overwrite _lastEventLanguage (needed for preview mode)
     * @return {*}
     */
    prepareCustomFilters(env, _document, translationTimeUnits, language) {
        if(language && (!this._lastProductEventLanguage || this._lastProductEventLanguage.length === 0)) {
            this._lastProductEventLanguage = language;
        }

        if(translationTimeUnits && (!this._translationTimeUnits || this._translationTimeUnits.length === 0)) {
            this._translationTimeUnits = translationTimeUnits;
        }

        env.addFilter('image_resize', function(str, size) {
            var newRegex = /fit=[^,]+,width=[0-9]+,height=[0-9]+/

            var sizeInfo = size.split('x');
            var width = 600;
            var height = 600;
            var operator = 1;

            if(typeof sizeInfo[0] !== 'undefined') width = sizeInfo[0];
            if(typeof sizeInfo[1] !== 'undefined') height = sizeInfo[1];
            if(typeof sizeInfo[2] !== 'undefined') operator = sizeInfo[2];

            switch(operator) {
                default:
                case '1':
                    operator = 'pad';
                    break;
                case '2':
                    operator = 'cover';
                    break;
                case '3':
                    operator = 'contain';
                    break;
                case '4':
                    operator = 'scale-down';
                    break;
            }
            str = str.replace(newRegex,'fit=' + operator + ',width=' + parseInt(width) + ',height=' + parseInt(height));
            return str;
        });

        env.addFilter('base64', function(str) {
            return btoa(str);
        });

        env.addGlobal('exposedCollections', function() {
            return '';
        });

        env.addFilter('escapejs', function(str) {
            if(typeof str === 'string') {
                var escapeJsCharacterMap = {
                    '\\': '\\u005C',
                    '\'': '\\u0027',
                    '"': '\\u0022',
                    '>': '\\u003E',
                    '<': '\\u003C',
                    '&': '\\u0026',
                    '=': '\\u003D',
                    '-': '\\u002D',
                    ';': '\\u003B'
                };
                return str.replace(/["'><&=\-;\\]/g, function(ch) {
                    return escapeJsCharacterMap[ch];
                });
            }

            return str;
        });

        env.addFilter('countdown', function(expirationDate, expiredText) {
            if(_document.hasOwnProperty('_sqzlyCountDownTimer') === false) {
                _document._sqzlyCountDownTimer = [];
            }

            expiredText = expiredText || '';

            if(expirationDate.match(/today|tomorrow|upcoming/)) {
                var strToDate = new Date();

                if(expirationDate.match(/upcoming/)) {
                    // let's try today
                    var temporaryDateStr = expirationDate.replace(/upcoming/, strToDate.getFullYear() + '-' + (parseInt(strToDate.getMonth()) + 1) + '-' + strToDate.getDate());

                    if(new Date(temporaryDateStr).getTime() < strToDate.getTime()) {
                        // Time already passed, so change to tomorrow
                        expirationDate = expirationDate.replace(/upcoming/, 'tomorrow');
                    }
                    else {
                        expirationDate = expirationDate.replace(/upcoming/, 'today');
                    }
                }

                if(expirationDate.match(/tomorrow/)) strToDate.setDate(strToDate.getDate() + 1);

                expirationDate = expirationDate.replace(/today|tomorrow/, strToDate.getFullYear() + '-' + (("0" + (strToDate.getMonth() + 1)).slice(-2)) + '-' + (("0" + strToDate.getDate()).slice(-2)));
            }

            // Add T for safari compatibility ('yyyy-mm-dd hh:mm:ss' -> 'yyyy-mm-ddThh:mm:ss')
            //                                ('yyyy-mm-dd hh:mm' -> 'yyyy-mm-ddThh:mm')
            // https://262.ecma-international.org/11.0/#sec-date-time-string-format
            // Page is huge so takes a while before page scrolls to anchor reference..
            expirationDate = expirationDate.replace(/(\d{4}(-\d{2}){2})\s*(\d{2}(:\d{2}){1,2})/g, '$1T$3');

            var countDownDate = new Date(expirationDate).getTime();
            if(isNaN(countDownDate)) {
                if(['debug', 'info', 'warning', 'error'].indexOf(sqzlCommon.getDebugLevel()) !== -1) {
                    console.error('sqzly: Could not parse DateTime format: ' + expirationDate);
                }
                return '';
            }

            var uniqid = '';
            while((uniqid = +Math.ceil(Math.random() * 5000)) && uniqid in _document._sqzlyCountDownTimer) {}
            _document._sqzlyCountDownTimer[uniqid] = setInterval(function() {
                this.calculateCountDown(_document, 'sqzly_countdown_' + uniqid, countDownDate, expiredText, uniqid);
            }.bind(this), 1000);

            // Call only after 200ms
            setTimeout(function() {
                this.calculateCountDown(_document, 'sqzly_countdown_' + uniqid, countDownDate, expiredText, uniqid);
            }.bind(this), 200);

            return '<span id="sqzly_countdown_' + uniqid + '" class="sqzly_countdown"></span>';
        }.bind(this))

        var originalDefaultFunction = env.getFilter('default');

        // If value is null, always go for the (old) boolean behaviour
        var defaultWithNullFallbackFunction = function(val, def, bool) {
            return originalDefaultFunction(val, def, val === null ? true : bool);
        };

        env.addFilter('default', defaultWithNullFallbackFunction);
        env.addFilter('d', defaultWithNullFallbackFunction);

        var customFilters = ['minimum', 'maximum', 'time_window', 'date_format', 'target_url'];

        customFilters.forEach(function(filterName) {
            env.addFilter(filterName, function(str) {
                return str;
            })
        });

        return env;
    }

    calculateCountDown(_document, elementId, countDownDate, expiredText, uniqid) {
        let element = _document.getElementById(elementId);
        if(typeof element === 'undefined' || !element) return false;

        // Get today's date and time
        let now = this.getCurrentTime(),
            // Find the distance between now and the count-down date
            distance = countDownDate - now,
            // Time calculations for days, hours, minutes and seconds
            days = Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if(hours < 10) hours = "0" + hours;
        if(minutes < 10) minutes = "0" + minutes;
        if(seconds < 10) seconds = "0" + seconds;

        let result = '',
            language = this.getLanguage(),
            langDaySingular = 'day',
            langDayPlural = 'days';
        language = language.split('-')[0].toLowerCase(); // if <lang>-<country>, then return only language part in lower case

        // days
        result += "<span class='days " + ((days === 0) ? "days_empty" : "")  +"'>" + days;
        if(this._translationTimeUnits && this._translationTimeUnits.hasOwnProperty(language)) {
            if(this._translationTimeUnits[language].hasOwnProperty('day')) {
                langDaySingular = this._translationTimeUnits[language]['day'];
            }
            if(this._translationTimeUnits[language].hasOwnProperty('days')) {
                langDayPlural = this._translationTimeUnits[language]['days'];
            }
        }

        if(days === 1) {
            result += '<span class="language_day"> ' + langDaySingular + '</span>';
        }
        else {
            result += '<span class="language_day"> ' + langDayPlural + '</span>';
        }
        result += "</span> ";

        result += "<span class='hours " + ((hours === "00") ? "hours_empty" : "") + "'>" + hours + ":</span>";
        result += "<span class='minutes " + ((minutes === "00") ? "minutes_empty" : "")  +"'>" + minutes + ":</span>";
        result += "<span class='seconds'>" + seconds + "</span>";

        // Display the result in the element with id="demo"
        element.innerHTML = result;

        // If the count-down is finished, write some text
        if(distance < 0 && uniqid in _document._sqzlyCountDownTimer) {
            clearInterval(_document._sqzlyCountDownTimer[uniqid]);
            element.innerHTML = '<span class="expired">' + expiredText + '</span>';
            delete _document._sqzlyCountDownTimer[uniqid];
        }

        return true;
    }

    renderAndReplaceInlineVariables(variables, items) {
        if(typeof items === 'undefined') return variables;

        let defaultProperties = [],
            parsedItems = [],
            listItemVariables = [
                'body',
                'button',
                'header',
                'image',
                'image_2',
                'image_original',
                'image_original_2',
                'image_square',
                'image_square_2',
                'image_url',
                'image_url_2',
                'position',
                'price',
                'product_id',
                'raw_price',
                'title',
                'url',
                'js',
            ],
            templateElements = variables.elements || {};

        for(let key in variables) {
            if(!variables.hasOwnProperty(key) || (typeof variables[key] === 'object' && key !== '_variantSettings')) continue;
            defaultProperties[key] = variables[key];
        }

        if(variables.hasOwnProperty('content_type') && variables.content_type.value === 'products') {
            for(let productIndex = 0; productIndex < variables.product_amount; productIndex++) {

                let parsedItem = items[productIndex];
                if(!parsedItem) continue;

                listItemVariables.forEach(function(key) {
                        let value = templateElements.hasOwnProperty(key) && templateElements[key].hasOwnProperty('value') ? String(templateElements[key].value) : null,
                            defaultValueUsed = false;
                        if(!value || value.length === 0) {
                            switch(key) {
                                case 'body':
                                    value = '{{brand}}';
                                    defaultValueUsed = true;
                                    break;
                                default:
                                    value = '{{' + key + '}}';
                                    defaultValueUsed = true;
                                    break;
                            }
                        }

                        if(key === 'js') {
                            // Add the escapejs filter so JS won't break on variables containing content
                            //  which will escape the string and break the JS parsability
                            value = this.addFilterToNunjucksVariables(value, 'escapejs', true);
                        }

                        try {
                            parsedItem[key] = this._njkEnv.renderString(value, items[productIndex]);
                        }
                        catch (err) {
                            if(!defaultValueUsed) value = ''; // return to empty value. error found and default value couldn't parse

                            parsedItem[key] = value.replace(/{/g, '&lbrace;');
                        }
                }.bind(this));

                parsedItems.push(parsedItem);
            }
            if(templateElements.hasOwnProperty('header') && templateElements['header'].hasOwnProperty('value')) {
                variables.header = templateElements.header.value;
            }
        }
        else {
            for(var parsedItemIndex = 0; parsedItemIndex < items.length; parsedItemIndex++) {
                var parsedItem = items[parsedItemIndex];
                defaultProperties = Object.assign({}, defaultProperties, parsedItem);

                listItemVariables.forEach(function(key) {
                    var value = templateElements.hasOwnProperty(key) && templateElements[key].hasOwnProperty('value') ? String(templateElements[key].value) : null;

                    if(!value || value.length === 0) {
                        switch(key) {
                            case 'body':
                                value = '{{brand}}';
                                break;
                            default:
                                value = '{{' + key + '}}';
                                break;
                        }
                    }

                    var properties = defaultProperties ? defaultProperties : {};
                    if(
                        key === 'url' &&
                        properties.hasOwnProperty(key)
                    ) {
                        var r = new RegExp(/(?:\{{2})(?:\s*)([^|\}\s]+)(?:|[^\}]+)?(?:\s*)(?:\}{2})/, 'g'),
                            match = null;

                        while(match = r.exec(properties[key])) {
                            let fieldMatchKey = match[1];
                            // This is a custom URL, containing at least one variable, so we need to render one level deeper
                            var urlReplaceValues = {};
                            if(fieldMatchKey === 'requestPushNotification') {
                                urlReplaceValues[fieldMatchKey] = 'javascript:sqzlCommon.requestPushNotification();';
                            }
                            else if(properties.hasOwnProperty(fieldMatchKey)) {
                                urlReplaceValues[fieldMatchKey] = properties[fieldMatchKey];
                            }
                            else if(variables.hasOwnProperty(fieldMatchKey)) {
                                urlReplaceValues[fieldMatchKey] = variables[fieldMatchKey];
                            }
                            else {
                                // This is not a key we can replace, we should leave the string intact
                                urlReplaceValues[fieldMatchKey] = '{{' + fieldMatchKey + '}}';
                            }

                            if(Object.keys(urlReplaceValues).length > 0) {
                                properties.url = this._njkEnv.renderString(properties.url, urlReplaceValues);
                            }
                        }
                    }

                    parsedItem[key] = this._njkEnv.renderString(value, properties);
                }.bind(this));

                parsedItems.push(parsedItem);
            }
        }

        if(parsedItems.length > 0) {
            variables.items = parsedItems;

            // One product available? Make all variables access with items.xxx
            if(parsedItems.length === 1) {
                variables = Object.assign({}, variables, parsedItems[0]);
            }
        }

        variables.cssPrefix = '#' + variables.divElementId;
        variables.cssPrefixEnabled = true;
        if(variables.hasOwnProperty('css') && variables.css.length > 0 && variables.hasOwnProperty('divElementId')) {
            var baseCss = variables.css;

            // When you clone the personalization the css(Prefix) is overwritten and can't be replaced anymore. So keep original and use that as base
            if(!variables.hasOwnProperty('originalCss')) {
                variables.originalCss = variables.css;
            }
            else {
                baseCss = variables.originalCss;
            }
            variables.css = this._njkEnv.renderString(baseCss, variables);
        }

        return variables;
    }

    /**
     * Adds a nunjucks filter to all variables in a template.
     *
     * Example:
     * template '{{ some_variable }}'
     * Becomes '{{ some_variable | filter }}'
     *
     * NOTE: If you change anything here, make sure util/templating.js is updated as well, that one is unit tested!
     *
     * @param {string} template The template containing the variables
     * @param {string} filter The filter to apply to all the variables in the template
     * @param {boolean} unique = true Only apply this filter if it has not been applied yet
     *
     * @return {string}
     */
    addFilterToNunjucksVariables(template, filter, unique) {
        if(typeof filter !== 'string' || filter === '') {
            return template;
        }
        if(typeof unique === 'undefined') {
            unique = true;
        }

        let matches = template.match(/\{{2}(?:(?!\{{2}|\}{2})[\s\S])*\}{2}/gmi);
        if(matches !== null) {
            let filterExistsTest = new RegExp('\\|\\s*' + filter, 'gmi');
            for(let i = 0; i < matches.length; i++) {
                if(!unique || filterExistsTest.test(matches[i]) === false) {
                    // Add the filter if not set, or set but no unique enabled
                    let withFilter = matches[i].replace('}}', '|' + filter + ' }}');
                    template = template.replace(matches[i], withFilter);
                }
            }
        }

        return template;
    }

    fetchPreview(cacheKey) {
        this.requireScript(this._document, this._dynamicBaseUrl + this._settings.pathPreview + cacheKey)
    }

    /**
     *
     * @param {HTMLDivElement} sqzlPersonalization
     * @param {Number} personalizationId
     * @param {Object} settings
     * @param {Object} personalization
     */
    queuePersonalizationIfNoProductFound(sqzlPersonalization, personalizationId, settings, personalization) {
        this._personalizationQueuedIfNoProductFound.push({
            sqzlPersonalization: sqzlPersonalization,
            settings: settings,
            personalization: personalization
        });

        this.setTimerQueuedPersonalization();
    }
    setTimerQueuedPersonalization() {
        if(this._personalizationQueuedIfNoProductFoundTimer) { // remove previous timer
            clearTimeout(this._personalizationQueuedIfNoProductFoundTimer);
        }
        else {
            if(this._settings.personalizationTriggerOnProductEventsFound.length > 0) {
                this._settings.personalizationTriggerOnProductEventsFound.forEach(function(event) {
                    this._personalizationQueuedForEvents.push({
                        settings: {
                            trigger_event_event: event,
                            trigger_event_fields: [],
                        },
                        divElement: null,
                        productTriggeredPersonalization: true,
                    });
                }.bind(this));
            }
        }

        this._personalizationQueuedIfNoProductFoundTimer = setTimeout(function() {
            this._settings.noProductFoundAfterWaiting = true;
            this._personalizationQueuedIfNoProductFound.forEach(function(data) {
                var settings = Object.assign({}, data.settings, {
                    noProductFoundAfterWaiting: true
                });
                this.insertOrReplaceContainerContent(data.sqzlPersonalization, settings, data.personalization);
            }.bind(this));
        }.bind(this), 1500);
    }

    /**
     *
     * @param {HTMLDivElement} sqzlPersonalization
     * @param {Object} settings
     * @param {Object=null} personalization
     * @param {Object=null} variant
     */
    insertOrReplaceContainerContent(sqzlPersonalization, settings, personalization, variant) {
        /**
         * @type {boolean|string}
         */
        let personalizationId = typeof settings.personalizationId !== 'undefined' ? settings.personalizationId : false,
            variantId = typeof settings.variantId !== 'undefined' ? settings.variantId : false,
            variantRevision = typeof settings.revision !== 'undefined' ? settings.revision : false,
            originalVariant = typeof settings.original_variant !== 'undefined' ? settings.original_variant : false,
            previewMode = typeof settings.previewMode !== 'undefined' ? settings.previewMode : false,
            noProductFoundAfterWaiting = typeof settings.noProductFoundAfterWaiting !== 'undefined' ? settings.noProductFoundAfterWaiting : false,
            triggeredByEventCheck = typeof settings.triggeredByEventCheck !== 'undefined' ? settings.triggeredByEventCheck : false;

        if(personalizationId && this._settings.triggeredPersonalizations.hasOwnProperty(personalizationId)) {
            return false; // already triggered
        }

        if(this._loadedPersonalizationIds.indexOf(personalizationId) < 0 && !previewMode) {
            // Not allowed to load personalization, probably a single-app application and ReloadPersonalization/PageReload is called
            // Preview mode is an exception
            return false;
        }

        if(variantId) {
            var styleHideElement = this._document.getElementById('_sqzlHE_' + variantId);
            if(styleHideElement) {
                styleHideElement.parentNode.removeChild(styleHideElement);
            }
        }

        var elementFound = false;

        if(
            settings.display_type === 'overlay' &&
            settings.trigger_type === 'product' &&
            this._settings.noProductFoundAfterWaiting &&
            this._personalizationQueuedIfNoProductFound.length > 0
        ) {
            return false; // personalization overlay arrived too late and other personalizations are queued, so skip showing it
        }

        if(settings.display_type === 'overlay') {
            this._sqzlContainer.appendChild(sqzlPersonalization);

            if(
                this._settings.personalizationTriggerOnProductEventsFound.length > 0 &&
                !noProductFoundAfterWaiting &&
                !triggeredByEventCheck &&
                settings.trigger_type !== 'pageload' // don't queue perso/wait for products if pageload to prevent trigger delay
            ) {
                this.queuePersonalizationIfNoProductFound(sqzlPersonalization, personalizationId, settings, personalization);
                if(settings.trigger_type === 'product') {
                    this.triggerPersonalizationsOnPixelEvents();
                }
                return false;
            }
            this.enableStyles(this._sqzlContainer);
            sqzlPersonalization.style.display = 'block';
            if(personalizationId) {
                this._settings.triggeredPersonalizations[personalizationId] = true;
            }
        }
        else if(settings.display_type === 'notification') {
            this._sqzlContainer.appendChild(sqzlPersonalization);
            this.enableStyles(this._sqzlContainer);
            sqzlPersonalization.style.display = 'block';
            if(personalizationId) {
                this._settings.triggeredPersonalizations[personalizationId] = true;
            }
        }
        else {
            var querySelector = settings.query_selector || settings.xpath;
            var elementFoundCheckRequired = false;

            if(
                originalVariant &&
                sqzlCommon.isDefined(settings, 'query_selectors') &&
                settings.query_selectors.length > 0
            ) {
                elementFound = this._document.querySelectorAll(settings.query_selectors.join(',')).length > 0;
                elementFoundCheckRequired = true;
            }

            if(querySelector && querySelector.length > 0) {
                elementFoundCheckRequired = true;

                if(querySelector.match(/>img/) && settings.insert_location === 'replace_content') {
                    settings.insert_location = 'replace';
                }

                if(variant && variant.hasOwnProperty('multiProducts') && variant.multiProducts === true && variant.items.length > 0) {
                    var productListerPageProductElementFound = false;
                    variant.items.forEach(function(item) {
                        var productQuerySelector = '[data-product-sku="' + item.product_id + '"] ' + querySelector + ', [data-product-id="' + item.product_id + '"] ' + querySelector;
                        var productDivElement = null;

                        if(this._document.querySelectorAll(productQuerySelector).length > 0) {
                            productListerPageProductElementFound = true;
                            productDivElement = this.renderAndInjectElement(personalization, settings, variant, [item], item.product_id);
                            elementFound = this.searchQuerySelectorAndReplaceElements(productDivElement, productQuerySelector, settings, originalVariant, personalizationId, variantId, variantRevision) || false;
                            if(elementFound) {
                                var productBlockElements = this._document.querySelectorAll('[data-product-sku="' + item.product_id + '"], [data-product-id="' + item.product_id + '"]');

                                productBlockElements.forEach(function(productElement) {
                                    this.bindElements(productElement, personalizationId, variantId, variantRevision, typeof settings.elements.button.new_window !== 'undefined' ? settings.elements.button.new_window : false, settings);
                                }.bind(this));
                            }
                        }
                    }.bind(this));

                    // Only fallback to querySelector if no product element was found and content type of variant isn't triggered_products
                    if(productListerPageProductElementFound === false && !(sqzlCommon.isDefined(settings, 'content_type.value') && settings.content_type.value === 'triggered_products')) {
                        elementFound = this.searchQuerySelectorAndReplaceElements(sqzlPersonalization, querySelector, settings, originalVariant, personalizationId, variantId, variantRevision) || elementFound;
                    }
                }
                else {
                    elementFound = this.searchQuerySelectorAndReplaceElements(sqzlPersonalization, querySelector, settings, originalVariant, personalizationId, variantId, variantRevision) || elementFound;
                }
            }

            // querySelector is set, but no element found
            if(!elementFound && elementFoundCheckRequired) {
                if(this._settings.personalizationTriggerOnProductEventsFound.length > 0 && !noProductFoundAfterWaiting && !triggeredByEventCheck) {
                    this.setTimerQueuedPersonalization();
                    this.triggerPersonalizationsOnPixelEvents();
                }
                else if(this._personalizationQueuedForEvents.length > 0 && triggeredByEventCheck) {
                    this.triggerPersonalizationsOnPixelEvents();
                }

                return false;
            }
        }

        if(!originalVariant) {
            if(settings.hasOwnProperty('closing_modal') && settings.closing_modal.hasOwnProperty('value')) {
                this._personalizationSettingCloseModalExpirationDays[personalizationId] = settings.closing_modal.value;
            }

            // These binds are mostly for non-HTML insert (overlay and notifications)
            this.bindElements(sqzlPersonalization, personalizationId, variantId, variantRevision, sqzlCommon.isDefined(settings, 'elements.button.new_window') ? settings.elements.button.new_window : false, settings);
        }
        if(variantId) {
            this.increaseViewCounter(variantId, settings, personalization);
        }

        if(this._settings.personalizationTriggerOnProductEventsFound.length > 0 && !noProductFoundAfterWaiting && !triggeredByEventCheck) {
            this.setTimerQueuedPersonalization();
            this.triggerPersonalizationsOnPixelEvents();
        }

        var additionalViewEventData = {
            control_variant: originalVariant,
            products: []
        };
        if(!noProductFoundAfterWaiting) {
            if(variant && variant.hasOwnProperty('items') && variant.items.length > 0) {
                variant.items.forEach(function(item) {
                    var productId = item.product_id;
                    if(typeof productId === 'undefined') {
                        return;
                    }
                    productId = productId.replace(/\{\{\s*product_id\s*\}\}/,'');
                    if(productId !== '') {
                        // Skip unparsed products (this happens in feedback forms for example)
                        additionalViewEventData.products.push({
                            id: item.product_id || 0,
                            title: item.title || '',
                            price: item.raw_price || 0,
                            position: item.position || 0
                        });
                    }
                });
            }
        }

        this.fireViewEvent(personalizationId, variantId, additionalViewEventData);
        if(originalVariant) {
            this._settings.triggeredPersonalizations[personalizationId] = true;
        }
        this.state.overlayOpen = true;
        if(settings.display_type === 'overlay') {
            this.state.overlayShown = true;
        }

        if(!settings.update && settings.js) {
            try {
                eval(settings.js);
            }
            catch(e) {
                console.error(`Spotler Activate: error in JS code (personalizationId: ${personalizationId}, variantId: ${variantId}): ${e}`);
            }

            // if no element found, but JS code is injected. Listen to all a.sqzl-clicks to track the links that are outside the sqzly container
            if(!elementFound) {
                this.bindAllClickElements(this._document, personalizationId, variantId, variantRevision);
            }
        }

        if(settings.lazy_load_images) {
            sqzlCommon.imgObserver.observe();
        }
    }

    /**
     *
     * @param {HTMLDivElement} sqzlPersonalization
     * @param {Object} settings
     * @param personalization
     * @param variant
     */
    insertOrReplaceContainerContentByEvent(sqzlPersonalization, settings, personalization, variant) {
        var allowedTriggerTypes = ['event', 'product'];
        if(allowedTriggerTypes.indexOf(settings.trigger_type) > -1 && settings.hasOwnProperty('trigger_event_fields')) {
            this._personalizationQueuedForEvents.push({
                divElement: sqzlPersonalization,
                settings: settings,
                personalization: personalization,
            });

            this.triggerPersonalizationsOnPixelEvents();
        }
    }

    bindElements(personalizationElement, personalizationId, variantId, variantRevision, ctaNewWindow, modalSettings) {
        ctaNewWindow = typeof ctaNewWindow !== 'undefined' ? ctaNewWindow : false;
        modalSettings = modalSettings || {};

        Array.prototype.forEach.call(personalizationElement.querySelectorAll('a'), function(element) {
            element.classList.add('sqzl-click');
            element.setAttribute('data-sqzl-personalization-id', personalizationId);
            element.setAttribute('data-sqzl-variant-id', variantId);
            element.setAttribute('data-sqzl-variant-revision', variantRevision);
            if(!element.hasAttribute('data-sqzl-new-window')) {
                element.setAttribute('data-sqzl-new-window', ctaNewWindow ? ctaNewWindow : typeof element.target !== 'undefined' && element.target === '_blank');
            }
        });

        if(modalSettings.fields) {
            var datePickerSettings = {altInput: true, altFormat: 'j F, Y'}; //can be overwritten

            for(let fieldIndex = 0; fieldIndex < modalSettings.fields.length; fieldIndex++) {
                if(modalSettings.fields[fieldIndex].type === 'date') {

                    datePickerSettings.dateFormat = 'Y-m-d';
                    if(modalSettings.fields[fieldIndex].id === 'birthdate') {
                        datePickerSettings.maxDate = new Date();
                    }

                    if(this._flatpickr) {
                        this._flatpickr("#sqzly_field_" + modalSettings.fields[fieldIndex].id, datePickerSettings);
                    }
                    else {
                        //now load the flatpickr package
                        const pickerCss = this._document.createElement('link');
                        pickerCss.rel = 'stylesheet';
                        pickerCss.type = 'text/css';
                        pickerCss.href = 'https://cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.4/flatpickr.min.css';
                        this._document.head.appendChild(pickerCss);

                        try {
                            /* flatpickr v4.5.4,, @license MIT */
                            /**
                             *  NOTE! When updating flatpickr, always remove this part from source --> "function"==typeof define&&define.amd?define(t): <--
                             *  Because magento (and other frameworks?) have their own define() function that isn't compatible with flatpickr's/webpack's define function
                             **/
                            !function(e,t){
                                e._flatpickr=t();
                                // "object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):
                            }(this,function(){"use strict";var e=function(){return(e=Object.assign||function(e){for(var t,n=1,a=arguments.length;n<a;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)},t=["onChange","onClose","onDayCreate","onDestroy","onKeyDown","onMonthChange","onOpen","onParseConfig","onReady","onValueUpdate","onYearChange","onPreCalendarPosition"],n={_disable:[],_enable:[],allowInput:!1,altFormat:"F j, Y",altInput:!1,altInputClass:"form-control input",animate:"object"==typeof window&&-1===window.navigator.userAgent.indexOf("MSIE"),ariaDateFormat:"F j, Y",clickOpens:!0,closeOnSelect:!0,conjunction:", ",dateFormat:"Y-m-d",defaultHour:12,defaultMinute:0,defaultSeconds:0,disable:[],disableMobile:!1,enable:[],enableSeconds:!1,enableTime:!1,errorHandler:function(e){return"undefined"!=typeof console&&console.warn(e)},getWeek:function(e){var t=new Date(e.getTime());t.setHours(0,0,0,0),t.setDate(t.getDate()+3-(t.getDay()+6)%7);var n=new Date(t.getFullYear(),0,4);return 1+Math.round(((t.getTime()-n.getTime())/864e5-3+(n.getDay()+6)%7)/7)},hourIncrement:1,ignoredFocusElements:[],inline:!1,locale:"default",minuteIncrement:5,mode:"single",nextArrow:"<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",noCalendar:!1,now:new Date,onChange:[],onClose:[],onDayCreate:[],onDestroy:[],onKeyDown:[],onMonthChange:[],onOpen:[],onParseConfig:[],onReady:[],onValueUpdate:[],onYearChange:[],onPreCalendarPosition:[],plugins:[],position:"auto",positionElement:void 0,prevArrow:"<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",shorthandCurrentMonth:!1,showMonths:1,static:!1,time_24hr:!1,weekNumbers:!1,wrap:!1},a={weekdays:{shorthand:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],longhand:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},months:{shorthand:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],longhand:["January","February","March","April","May","June","July","August","September","October","November","December"]},daysInMonth:[31,28,31,30,31,30,31,31,30,31,30,31],firstDayOfWeek:0,ordinal:function(e){var t=e%100;if(t>3&&t<21)return"th";switch(t%10){case 1:return"st";case 2:return"nd";case 3:return"rd";default:return"th"}},rangeSeparator:" to ",weekAbbreviation:"Wk",scrollTitle:"Scroll to increment",toggleTitle:"Click to toggle",amPM:["AM","PM"],yearAriaLabel:"Year"},i=function(e){return("0"+e).slice(-2)},o=function(e){return!0===e?1:0};function r(e,t,n){var a;return void 0===n&&(n=!1),function(){var i=this,o=arguments;null!==a&&clearTimeout(a),a=window.setTimeout(function(){a=null,n||e.apply(i,o)},t),n&&!a&&e.apply(i,o)}}var l=function(e){return e instanceof Array?e:[e]};function c(e,t,n){if(!0===n)return e.classList.add(t);e.classList.remove(t)}function d(e,t,n){var a=window.document.createElement(e);return t=t||"",n=n||"",a.className=t,void 0!==n&&(a.textContent=n),a}function s(e){for(;e.firstChild;)e.removeChild(e.firstChild)}function u(e,t){var n=d("div","numInputWrapper"),a=d("input","numInput "+e),i=d("span","arrowUp"),o=d("span","arrowDown");if(a.type="text",a.pattern="\\d*",void 0!==t)for(var r in t)a.setAttribute(r,t[r]);return n.appendChild(a),n.appendChild(i),n.appendChild(o),n}var f=function(){},m=function(e,t,n){return n.months[t?"shorthand":"longhand"][e]},g={D:f,F:function(e,t,n){e.setMonth(n.months.longhand.indexOf(t))},G:function(e,t){e.setHours(parseFloat(t))},H:function(e,t){e.setHours(parseFloat(t))},J:function(e,t){e.setDate(parseFloat(t))},K:function(e,t,n){e.setHours(e.getHours()%12+12*o(new RegExp(n.amPM[1],"i").test(t)))},M:function(e,t,n){e.setMonth(n.months.shorthand.indexOf(t))},S:function(e,t){e.setSeconds(parseFloat(t))},U:function(e,t){return new Date(1e3*parseFloat(t))},W:function(e,t){var n=parseInt(t);return new Date(e.getFullYear(),0,2+7*(n-1),0,0,0,0)},Y:function(e,t){e.setFullYear(parseFloat(t))},Z:function(e,t){return new Date(t)},d:function(e,t){e.setDate(parseFloat(t))},h:function(e,t){e.setHours(parseFloat(t))},i:function(e,t){e.setMinutes(parseFloat(t))},j:function(e,t){e.setDate(parseFloat(t))},l:f,m:function(e,t){e.setMonth(parseFloat(t)-1)},n:function(e,t){e.setMonth(parseFloat(t)-1)},s:function(e,t){e.setSeconds(parseFloat(t))},u:function(e,t){return new Date(parseFloat(t))},w:f,y:function(e,t){e.setFullYear(2e3+parseFloat(t))}},p={D:"(\\w+)",F:"(\\w+)",G:"(\\d\\d|\\d)",H:"(\\d\\d|\\d)",J:"(\\d\\d|\\d)\\w+",K:"",M:"(\\w+)",S:"(\\d\\d|\\d)",U:"(.+)",W:"(\\d\\d|\\d)",Y:"(\\d{4})",Z:"(.+)",d:"(\\d\\d|\\d)",h:"(\\d\\d|\\d)",i:"(\\d\\d|\\d)",j:"(\\d\\d|\\d)",l:"(\\w+)",m:"(\\d\\d|\\d)",n:"(\\d\\d|\\d)",s:"(\\d\\d|\\d)",u:"(.+)",w:"(\\d\\d|\\d)",y:"(\\d{2})"},h={Z:function(e){return e.toISOString()},D:function(e,t,n){return t.weekdays.shorthand[h.w(e,t,n)]},F:function(e,t,n){return m(h.n(e,t,n)-1,!1,t)},G:function(e,t,n){return i(h.h(e,t,n))},H:function(e){return i(e.getHours())},J:function(e,t){return void 0!==t.ordinal?e.getDate()+t.ordinal(e.getDate()):e.getDate()},K:function(e,t){return t.amPM[o(e.getHours()>11)]},M:function(e,t){return m(e.getMonth(),!0,t)},S:function(e){return i(e.getSeconds())},U:function(e){return e.getTime()/1e3},W:function(e,t,n){return n.getWeek(e)},Y:function(e){return e.getFullYear()},d:function(e){return i(e.getDate())},h:function(e){return e.getHours()%12?e.getHours()%12:12},i:function(e){return i(e.getMinutes())},j:function(e){return e.getDate()},l:function(e,t){return t.weekdays.longhand[e.getDay()]},m:function(e){return i(e.getMonth()+1)},n:function(e){return e.getMonth()+1},s:function(e){return e.getSeconds()},u:function(e){return e.getTime()},w:function(e){return e.getDay()},y:function(e){return String(e.getFullYear()).substring(2)}},v=function(e){var t=e.config,i=void 0===t?n:t,o=e.l10n,r=void 0===o?a:o;return function(e,t,n){var a=n||r;return void 0!==i.formatDate?i.formatDate(e,t,a):t.split("").map(function(t,n,o){return h[t]&&"\\"!==o[n-1]?h[t](e,a,i):"\\"!==t?t:""}).join("")}},D=function(e){var t=e.config,i=void 0===t?n:t,o=e.l10n,r=void 0===o?a:o;return function(e,t,a,o){if(0===e||e){var l,c=o||r,d=e;if(e instanceof Date)l=new Date(e.getTime());else if("string"!=typeof e&&void 0!==e.toFixed)l=new Date(e);else if("string"==typeof e){var s=t||(i||n).dateFormat,u=String(e).trim();if("today"===u)l=new Date,a=!0;else if(/Z$/.test(u)||/GMT$/.test(u))l=new Date(e);else if(i&&i.parseDate)l=i.parseDate(e,s);else{l=i&&i.noCalendar?new Date((new Date).setHours(0,0,0,0)):new Date((new Date).getFullYear(),0,1,0,0,0,0);for(var f=void 0,m=[],h=0,v=0,D="";h<s.length;h++){var w=s[h],b="\\"===w,C="\\"===s[h-1]||b;if(p[w]&&!C){D+=p[w];var y=new RegExp(D).exec(e);y&&(f=!0)&&m["Y"!==w?"push":"unshift"]({fn:g[w],val:y[++v]})}else b||(D+=".");m.forEach(function(e){var t=e.fn,n=e.val;return l=t(l,n,c)||l})}l=f?l:void 0}}if(l instanceof Date&&!isNaN(l.getTime()))return!0===a&&l.setHours(0,0,0,0),l;i.errorHandler(new Error("Invalid date provided: "+d))}}};function w(e,t,n){return void 0===n&&(n=!0),!1!==n?new Date(e.getTime()).setHours(0,0,0,0)-new Date(t.getTime()).setHours(0,0,0,0):e.getTime()-t.getTime()}var b=function(e,t,n){return e>Math.min(t,n)&&e<Math.max(t,n)},C={DAY:864e5};"function"!=typeof Object.assign&&(Object.assign=function(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];if(!e)throw TypeError("Cannot convert undefined or null to object");for(var a=function(t){t&&Object.keys(t).forEach(function(n){return e[n]=t[n]})},i=0,o=t;i<o.length;i++){a(o[i])}return e});var y=300;function M(n,f){var g={config:e({},E.defaultConfig),l10n:a};function h(e){return e.bind(g)}function M(){var e=g.config;!1===e.weekNumbers&&1===e.showMonths||!0!==e.noCalendar&&window.requestAnimationFrame(function(){if(void 0!==g.calendarContainer&&(g.calendarContainer.style.visibility="hidden",g.calendarContainer.style.display="block"),void 0!==g.daysContainer){var t=(g.days.offsetWidth+1)*e.showMonths;g.daysContainer.style.width=t+"px",g.calendarContainer.style.width=t+(void 0!==g.weekWrapper?g.weekWrapper.offsetWidth:0)+"px",g.calendarContainer.style.removeProperty("visibility"),g.calendarContainer.style.removeProperty("display")}})}function x(e){if(0!==g.selectedDates.length){void 0!==e&&"blur"!==e.type&&function(e){e.preventDefault();var t="keydown"===e.type,n=e.target;void 0!==g.amPM&&e.target===g.amPM&&(g.amPM.textContent=g.l10n.amPM[o(g.amPM.textContent===g.l10n.amPM[0])]);var a=parseFloat(n.getAttribute("data-min")),r=parseFloat(n.getAttribute("data-max")),l=parseFloat(n.getAttribute("data-step")),c=parseInt(n.value,10),d=e.delta||(t?38===e.which?1:-1:0),s=c+l*d;if(void 0!==n.value&&2===n.value.length){var u=n===g.hourElement,f=n===g.minuteElement;s<a?(s=r+s+o(!u)+(o(u)&&o(!g.amPM)),f&&Y(void 0,-1,g.hourElement)):s>r&&(s=n===g.hourElement?s-r-o(!g.amPM):a,f&&Y(void 0,1,g.hourElement)),g.amPM&&u&&(1===l?s+c===23:Math.abs(s-c)>l)&&(g.amPM.textContent=g.l10n.amPM[o(g.amPM.textContent===g.l10n.amPM[0])]),n.value=i(s)}}(e);var t=g._input.value;T(),he(),g._input.value!==t&&g._debouncedChange()}}function T(){if(void 0!==g.hourElement&&void 0!==g.minuteElement){var e,t,n=(parseInt(g.hourElement.value.slice(-2),10)||0)%24,a=(parseInt(g.minuteElement.value,10)||0)%60,i=void 0!==g.secondElement?(parseInt(g.secondElement.value,10)||0)%60:0;void 0!==g.amPM&&(e=n,t=g.amPM.textContent,n=e%12+12*o(t===g.l10n.amPM[1]));var r=void 0!==g.config.minTime||g.config.minDate&&g.minDateHasTime&&g.latestSelectedDateObj&&0===w(g.latestSelectedDateObj,g.config.minDate,!0);if(void 0!==g.config.maxTime||g.config.maxDate&&g.maxDateHasTime&&g.latestSelectedDateObj&&0===w(g.latestSelectedDateObj,g.config.maxDate,!0)){var l=void 0!==g.config.maxTime?g.config.maxTime:g.config.maxDate;(n=Math.min(n,l.getHours()))===l.getHours()&&(a=Math.min(a,l.getMinutes())),a===l.getMinutes()&&(i=Math.min(i,l.getSeconds()))}if(r){var c=void 0!==g.config.minTime?g.config.minTime:g.config.minDate;(n=Math.max(n,c.getHours()))===c.getHours()&&(a=Math.max(a,c.getMinutes())),a===c.getMinutes()&&(i=Math.max(i,c.getSeconds()))}O(n,a,i)}}function k(e){var t=e||g.latestSelectedDateObj;t&&O(t.getHours(),t.getMinutes(),t.getSeconds())}function I(){var e=g.config.defaultHour,t=g.config.defaultMinute,n=g.config.defaultSeconds;if(void 0!==g.config.minDate){var a=g.config.minDate.getHours(),i=g.config.minDate.getMinutes();(e=Math.max(e,a))===a&&(t=Math.max(i,t)),e===a&&t===i&&(n=g.config.minDate.getSeconds())}if(void 0!==g.config.maxDate){var o=g.config.maxDate.getHours(),r=g.config.maxDate.getMinutes();(e=Math.min(e,o))===o&&(t=Math.min(r,t)),e===o&&t===r&&(n=g.config.maxDate.getSeconds())}O(e,t,n)}function O(e,t,n){void 0!==g.latestSelectedDateObj&&g.latestSelectedDateObj.setHours(e%24,t,n||0,0),g.hourElement&&g.minuteElement&&!g.isMobile&&(g.hourElement.value=i(g.config.time_24hr?e:(12+e)%12+12*o(e%12==0)),g.minuteElement.value=i(t),void 0!==g.amPM&&(g.amPM.textContent=g.l10n.amPM[o(e>=12)]),void 0!==g.secondElement&&(g.secondElement.value=i(n)))}function S(e){var t=parseInt(e.target.value)+(e.delta||0);(t/1e3>1||"Enter"===e.key&&!/[^\d]/.test(t.toString()))&&V(t)}function _(e,t,n,a){return t instanceof Array?t.forEach(function(t){return _(e,t,n,a)}):e instanceof Array?e.forEach(function(e){return _(e,t,n,a)}):(e.addEventListener(t,n,a),void g._handlers.push({element:e,event:t,handler:n,options:a}))}function N(e){return function(t){1===t.which&&e(t)}}function F(){ue("onChange")}function P(e){var t=void 0!==e?g.parseDate(e):g.latestSelectedDateObj||(g.config.minDate&&g.config.minDate>g.now?g.config.minDate:g.config.maxDate&&g.config.maxDate<g.now?g.config.maxDate:g.now);try{void 0!==t&&(g.currentYear=t.getFullYear(),g.currentMonth=t.getMonth())}catch(e){e.message="Invalid date supplied: "+t,g.config.errorHandler(e)}g.redraw()}function A(e){~e.target.className.indexOf("arrow")&&Y(e,e.target.classList.contains("arrowUp")?1:-1)}function Y(e,t,n){var a=e&&e.target,i=n||a&&a.parentNode&&a.parentNode.firstChild,o=fe("increment");o.delta=t,i&&i.dispatchEvent(o)}function j(e,t,n,a){var i=Z(t,!0),o=d("span","flatpickr-day "+e,t.getDate().toString());return o.dateObj=t,o.$i=a,o.setAttribute("aria-label",g.formatDate(t,g.config.ariaDateFormat)),-1===e.indexOf("hidden")&&0===w(t,g.now)&&(g.todayDateElem=o,o.classList.add("today"),o.setAttribute("aria-current","date")),i?(o.tabIndex=-1,me(t)&&(o.classList.add("selected"),g.selectedDateElem=o,"range"===g.config.mode&&(c(o,"startRange",g.selectedDates[0]&&0===w(t,g.selectedDates[0],!0)),c(o,"endRange",g.selectedDates[1]&&0===w(t,g.selectedDates[1],!0)),"nextMonthDay"===e&&o.classList.add("inRange")))):o.classList.add("disabled"),"range"===g.config.mode&&function(e){return!("range"!==g.config.mode||g.selectedDates.length<2)&&w(e,g.selectedDates[0])>=0&&w(e,g.selectedDates[1])<=0}(t)&&!me(t)&&o.classList.add("inRange"),g.weekNumbers&&1===g.config.showMonths&&"prevMonthDay"!==e&&n%7==1&&g.weekNumbers.insertAdjacentHTML("beforeend","<span class='flatpickr-day'>"+g.config.getWeek(t)+"</span>"),ue("onDayCreate",o),o}function H(e){e.focus(),"range"===g.config.mode&&ee(e)}function L(e){for(var t=e>0?0:g.config.showMonths-1,n=e>0?g.config.showMonths:-1,a=t;a!=n;a+=e)for(var i=g.daysContainer.children[a],o=e>0?0:i.children.length-1,r=e>0?i.children.length:-1,l=o;l!=r;l+=e){var c=i.children[l];if(-1===c.className.indexOf("hidden")&&Z(c.dateObj))return c}}function W(e,t){var n=Q(document.activeElement||document.body),a=void 0!==e?e:n?document.activeElement:void 0!==g.selectedDateElem&&Q(g.selectedDateElem)?g.selectedDateElem:void 0!==g.todayDateElem&&Q(g.todayDateElem)?g.todayDateElem:L(t>0?1:-1);return void 0===a?g._input.focus():n?void function(e,t){for(var n=-1===e.className.indexOf("Month")?e.dateObj.getMonth():g.currentMonth,a=t>0?g.config.showMonths:-1,i=t>0?1:-1,o=n-g.currentMonth;o!=a;o+=i)for(var r=g.daysContainer.children[o],l=n-g.currentMonth===o?e.$i+t:t<0?r.children.length-1:0,c=r.children.length,d=l;d>=0&&d<c&&d!=(t>0?c:-1);d+=i){var s=r.children[d];if(-1===s.className.indexOf("hidden")&&Z(s.dateObj)&&Math.abs(e.$i-d)>=Math.abs(t))return H(s)}g.changeMonth(i),W(L(i),0)}(a,t):H(a)}function R(e,t){for(var n=(new Date(e,t,1).getDay()-g.l10n.firstDayOfWeek+7)%7,a=g.utils.getDaysInMonth((t-1+12)%12),i=g.utils.getDaysInMonth(t),o=window.document.createDocumentFragment(),r=g.config.showMonths>1,l=r?"prevMonthDay hidden":"prevMonthDay",c=r?"nextMonthDay hidden":"nextMonthDay",s=a+1-n,u=0;s<=a;s++,u++)o.appendChild(j(l,new Date(e,t-1,s),s,u));for(s=1;s<=i;s++,u++)o.appendChild(j("",new Date(e,t,s),s,u));for(var f=i+1;f<=42-n&&(1===g.config.showMonths||u%7!=0);f++,u++)o.appendChild(j(c,new Date(e,t+1,f%i),f,u));var m=d("div","dayContainer");return m.appendChild(o),m}function B(){if(void 0!==g.daysContainer){s(g.daysContainer),g.weekNumbers&&s(g.weekNumbers);for(var e=document.createDocumentFragment(),t=0;t<g.config.showMonths;t++){var n=new Date(g.currentYear,g.currentMonth,1);n.setMonth(g.currentMonth+t),e.appendChild(R(n.getFullYear(),n.getMonth()))}g.daysContainer.appendChild(e),g.days=g.daysContainer.firstChild,"range"===g.config.mode&&1===g.selectedDates.length&&ee()}}function K(){var e=d("div","flatpickr-month"),t=window.document.createDocumentFragment(),n=d("span","cur-month"),a=u("cur-year",{tabindex:"-1"}),i=a.getElementsByTagName("input")[0];i.setAttribute("aria-label",g.l10n.yearAriaLabel),g.config.minDate&&i.setAttribute("data-min",g.config.minDate.getFullYear().toString()),g.config.maxDate&&(i.setAttribute("data-max",g.config.maxDate.getFullYear().toString()),i.disabled=!!g.config.minDate&&g.config.minDate.getFullYear()===g.config.maxDate.getFullYear());var o=d("div","flatpickr-current-month");return o.appendChild(n),o.appendChild(a),t.appendChild(o),e.appendChild(t),{container:e,yearElement:i,monthElement:n}}function J(){s(g.monthNav),g.monthNav.appendChild(g.prevMonthNav),g.config.showMonths&&(g.yearElements=[],g.monthElements=[]);for(var e=g.config.showMonths;e--;){var t=K();g.yearElements.push(t.yearElement),g.monthElements.push(t.monthElement),g.monthNav.appendChild(t.container)}g.monthNav.appendChild(g.nextMonthNav)}function U(){g.weekdayContainer?s(g.weekdayContainer):g.weekdayContainer=d("div","flatpickr-weekdays");for(var e=g.config.showMonths;e--;){var t=d("div","flatpickr-weekdaycontainer");g.weekdayContainer.appendChild(t)}return q(),g.weekdayContainer}function q(){var e=g.l10n.firstDayOfWeek,t=g.l10n.weekdays.shorthand.slice();e>0&&e<t.length&&(t=t.splice(e,t.length).concat(t.splice(0,e)));for(var n=g.config.showMonths;n--;)g.weekdayContainer.children[n].innerHTML="\n      <span class='flatpickr-weekday'>\n        "+t.join("</span><span class='flatpickr-weekday'>")+"\n      </span>\n      "}function $(e,t){void 0===t&&(t=!0);var n=t?e:e-g.currentMonth;n<0&&!0===g._hidePrevMonthArrow||n>0&&!0===g._hideNextMonthArrow||(g.currentMonth+=n,(g.currentMonth<0||g.currentMonth>11)&&(g.currentYear+=g.currentMonth>11?1:-1,g.currentMonth=(g.currentMonth+12)%12,ue("onYearChange")),B(),ue("onMonthChange"),ge())}function z(e){return!(!g.config.appendTo||!g.config.appendTo.contains(e))||g.calendarContainer.contains(e)}function G(e){if(g.isOpen&&!g.config.inline){var t="function"==typeof(r=e).composedPath?r.composedPath()[0]:r.target,n=z(t),a=t===g.input||t===g.altInput||g.element.contains(t)||e.path&&e.path.indexOf&&(~e.path.indexOf(g.input)||~e.path.indexOf(g.altInput)),i="blur"===e.type?a&&e.relatedTarget&&!z(e.relatedTarget):!a&&!n&&!z(e.relatedTarget),o=!g.config.ignoredFocusElements.some(function(e){return e.contains(t)});i&&o&&(x(),g.close(),"range"===g.config.mode&&1===g.selectedDates.length&&(g.clear(!1),g.redraw()))}var r}function V(e){if(!(!e||g.config.minDate&&e<g.config.minDate.getFullYear()||g.config.maxDate&&e>g.config.maxDate.getFullYear())){var t=e,n=g.currentYear!==t;g.currentYear=t||g.currentYear,g.config.maxDate&&g.currentYear===g.config.maxDate.getFullYear()?g.currentMonth=Math.min(g.config.maxDate.getMonth(),g.currentMonth):g.config.minDate&&g.currentYear===g.config.minDate.getFullYear()&&(g.currentMonth=Math.max(g.config.minDate.getMonth(),g.currentMonth)),n&&(g.redraw(),ue("onYearChange"))}}function Z(e,t){void 0===t&&(t=!0);var n=g.parseDate(e,void 0,t);if(g.config.minDate&&n&&w(n,g.config.minDate,void 0!==t?t:!g.minDateHasTime)<0||g.config.maxDate&&n&&w(n,g.config.maxDate,void 0!==t?t:!g.maxDateHasTime)>0)return!1;if(0===g.config.enable.length&&0===g.config.disable.length)return!0;if(void 0===n)return!1;for(var a=g.config.enable.length>0,i=a?g.config.enable:g.config.disable,o=0,r=void 0;o<i.length;o++){if("function"==typeof(r=i[o])&&r(n))return a;if(r instanceof Date&&void 0!==n&&r.getTime()===n.getTime())return a;if("string"==typeof r&&void 0!==n){var l=g.parseDate(r,void 0,!0);return l&&l.getTime()===n.getTime()?a:!a}if("object"==typeof r&&void 0!==n&&r.from&&r.to&&n.getTime()>=r.from.getTime()&&n.getTime()<=r.to.getTime())return a}return!a}function Q(e){return void 0!==g.daysContainer&&(-1===e.className.indexOf("hidden")&&g.daysContainer.contains(e))}function X(e){var t=e.target===g._input,n=g.config.allowInput,a=g.isOpen&&(!n||!t),i=g.config.inline&&t&&!n;if(13===e.keyCode&&t){if(n)return g.setDate(g._input.value,!0,e.target===g.altInput?g.config.altFormat:g.config.dateFormat),e.target.blur();g.open()}else if(z(e.target)||a||i){var o=!!g.timeContainer&&g.timeContainer.contains(e.target);switch(e.keyCode){case 13:o?x():le(e);break;case 27:e.preventDefault(),re();break;case 8:case 46:t&&!g.config.allowInput&&(e.preventDefault(),g.clear());break;case 37:case 39:if(o)g.hourElement&&g.hourElement.focus();else if(e.preventDefault(),void 0!==g.daysContainer&&(!1===n||document.activeElement&&Q(document.activeElement))){var r=39===e.keyCode?1:-1;e.ctrlKey?(e.stopPropagation(),$(r),W(L(1),0)):W(void 0,r)}break;case 38:case 40:e.preventDefault();var l=40===e.keyCode?1:-1;g.daysContainer&&void 0!==e.target.$i||e.target===g.input?e.ctrlKey?(e.stopPropagation(),V(g.currentYear-l),W(L(1),0)):o||W(void 0,7*l):g.config.enableTime&&(!o&&g.hourElement&&g.hourElement.focus(),x(e),g._debouncedChange());break;case 9:var c=g.calendarContainer.childElementCount,d=0;if(g.config.enableTime&&(d+=1),g.config.noCalendar||(d+=2),o){var s=[g.hourElement,g.minuteElement,g.secondElement,g.amPM].filter(function(e){return e}),u=s.indexOf(e.target);if(-1!==u){var f=s[u+(e.shiftKey?-1:1)];void 0!==f?(e.preventDefault(),f.focus()):c<=d&&g.element.focus()}break}c<=d&&g.element.focus()}}if(void 0!==g.amPM&&e.target===g.amPM)switch(e.key){case g.l10n.amPM[0].charAt(0):case g.l10n.amPM[0].charAt(0).toLowerCase():g.amPM.textContent=g.l10n.amPM[0],T(),he();break;case g.l10n.amPM[1].charAt(0):case g.l10n.amPM[1].charAt(0).toLowerCase():g.amPM.textContent=g.l10n.amPM[1],T(),he()}ue("onKeyDown",e)}function ee(e){if(1===g.selectedDates.length&&(!e||e.classList.contains("flatpickr-day")&&!e.classList.contains("disabled"))){for(var t=e?e.dateObj.getTime():g.days.firstElementChild.dateObj.getTime(),n=g.parseDate(g.selectedDates[0],void 0,!0).getTime(),a=Math.min(t,g.selectedDates[0].getTime()),i=Math.max(t,g.selectedDates[0].getTime()),o=g.daysContainer.lastChild.lastChild.dateObj.getTime(),r=!1,l=0,c=0,d=a;d<o;d+=C.DAY)Z(new Date(d),!0)||(r=r||d>a&&d<i,d<n&&(!l||d>l)?l=d:d>n&&(!c||d<c)&&(c=d));for(var s=0;s<g.config.showMonths;s++)for(var u=g.daysContainer.children[s],f=g.daysContainer.children[s-1],m=function(a,i){var o=u.children[a],d=o.dateObj.getTime(),m=l>0&&d<l||c>0&&d>c;return m?(o.classList.add("notAllowed"),["inRange","startRange","endRange"].forEach(function(e){o.classList.remove(e)}),"continue"):r&&!m?"continue":(["startRange","inRange","endRange","notAllowed"].forEach(function(e){o.classList.remove(e)}),void(void 0!==e&&(e.classList.add(t<g.selectedDates[0].getTime()?"startRange":"endRange"),!u.contains(e)&&s>0&&f&&f.lastChild.dateObj.getTime()>=d||(n<t&&d===n?o.classList.add("startRange"):n>t&&d===n&&o.classList.add("endRange"),d>=l&&(0===c||d<=c)&&b(d,n,t)&&o.classList.add("inRange")))))},p=0,h=u.children.length;p<h;p++)m(p)}}function te(){!g.isOpen||g.config.static||g.config.inline||ie()}function ne(e){return function(t){var n=g.config["_"+e+"Date"]=g.parseDate(t,g.config.dateFormat),a=g.config["_"+("min"===e?"max":"min")+"Date"];void 0!==n&&(g["min"===e?"minDateHasTime":"maxDateHasTime"]=n.getHours()>0||n.getMinutes()>0||n.getSeconds()>0),g.selectedDates&&(g.selectedDates=g.selectedDates.filter(function(e){return Z(e)}),g.selectedDates.length||"min"!==e||k(n),he()),g.daysContainer&&(oe(),void 0!==n?g.currentYearElement[e]=n.getFullYear().toString():g.currentYearElement.removeAttribute(e),g.currentYearElement.disabled=!!a&&void 0!==n&&a.getFullYear()===n.getFullYear())}}function ae(){"object"!=typeof g.config.locale&&void 0===E.l10ns[g.config.locale]&&g.config.errorHandler(new Error("flatpickr: invalid locale "+g.config.locale)),g.l10n=e({},E.l10ns.default,"object"==typeof g.config.locale?g.config.locale:"default"!==g.config.locale?E.l10ns[g.config.locale]:void 0),p.K="("+g.l10n.amPM[0]+"|"+g.l10n.amPM[1]+"|"+g.l10n.amPM[0].toLowerCase()+"|"+g.l10n.amPM[1].toLowerCase()+")",g.formatDate=v(g),g.parseDate=D({config:g.config,l10n:g.l10n})}function ie(e){if(void 0!==g.calendarContainer){ue("onPreCalendarPosition");var t=e||g._positionElement,n=Array.prototype.reduce.call(g.calendarContainer.children,function(e,t){return e+t.offsetHeight},0),a=g.calendarContainer.offsetWidth,i=g.config.position.split(" "),o=i[0],r=i.length>1?i[1]:null,l=t.getBoundingClientRect(),d=window.innerHeight-l.bottom,s="above"===o||"below"!==o&&d<n&&l.top>n,u=window.pageYOffset+l.top+(s?-n-2:t.offsetHeight+2);if(c(g.calendarContainer,"arrowTop",!s),c(g.calendarContainer,"arrowBottom",s),!g.config.inline){var f=window.pageXOffset+l.left-(null!=r&&"center"===r?(a-l.width)/2:0),m=window.document.body.offsetWidth-l.right,p=f+a>window.document.body.offsetWidth,h=m+a>window.document.body.offsetWidth;if(c(g.calendarContainer,"rightMost",p),!g.config.static)if(g.calendarContainer.style.top=u+"px",p)if(h){var v=document.styleSheets[0],D=window.document.body.offsetWidth,w=Math.max(0,D/2-a/2),b=v.cssRules.length,C="{left:"+l.left+"px;right:auto;}";c(g.calendarContainer,"rightMost",!1),c(g.calendarContainer,"centerMost",!0),v.insertRule(".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after"+C,b),g.calendarContainer.style.left=w+"px",g.calendarContainer.style.right="auto"}else g.calendarContainer.style.left="auto",g.calendarContainer.style.right=m+"px";else g.calendarContainer.style.left=f+"px",g.calendarContainer.style.right="auto"}}}function oe(){g.config.noCalendar||g.isMobile||(ge(),B())}function re(){g._input.focus(),-1!==window.navigator.userAgent.indexOf("MSIE")||void 0!==navigator.msMaxTouchPoints?setTimeout(g.close,0):g.close()}function le(e){e.preventDefault(),e.stopPropagation();var t=function e(t,n){return n(t)?t:t.parentNode?e(t.parentNode,n):void 0}(e.target,function(e){return e.classList&&e.classList.contains("flatpickr-day")&&!e.classList.contains("disabled")&&!e.classList.contains("notAllowed")});if(void 0!==t){var n=t,a=g.latestSelectedDateObj=new Date(n.dateObj.getTime()),i=(a.getMonth()<g.currentMonth||a.getMonth()>g.currentMonth+g.config.showMonths-1)&&"range"!==g.config.mode;if(g.selectedDateElem=n,"single"===g.config.mode)g.selectedDates=[a];else if("multiple"===g.config.mode){var o=me(a);o?g.selectedDates.splice(parseInt(o),1):g.selectedDates.push(a)}else"range"===g.config.mode&&(2===g.selectedDates.length&&g.clear(!1),g.latestSelectedDateObj=a,g.selectedDates.push(a),0!==w(a,g.selectedDates[0],!0)&&g.selectedDates.sort(function(e,t){return e.getTime()-t.getTime()}));if(T(),i){var r=g.currentYear!==a.getFullYear();g.currentYear=a.getFullYear(),g.currentMonth=a.getMonth(),r&&ue("onYearChange"),ue("onMonthChange")}if(ge(),B(),he(),g.config.enableTime&&setTimeout(function(){return g.showTimeInput=!0},50),i||"range"===g.config.mode||1!==g.config.showMonths?void 0!==g.selectedDateElem&&void 0===g.hourElement&&g.selectedDateElem&&g.selectedDateElem.focus():H(n),void 0!==g.hourElement&&void 0!==g.hourElement&&g.hourElement.focus(),g.config.closeOnSelect){var l="single"===g.config.mode&&!g.config.enableTime,c="range"===g.config.mode&&2===g.selectedDates.length&&!g.config.enableTime;(l||c)&&re()}F()}}g.parseDate=D({config:g.config,l10n:g.l10n}),g._handlers=[],g._bind=_,g._setHoursFromDate=k,g._positionCalendar=ie,g.changeMonth=$,g.changeYear=V,g.clear=function(e){void 0===e&&(e=!0);g.input.value="",void 0!==g.altInput&&(g.altInput.value="");void 0!==g.mobileInput&&(g.mobileInput.value="");g.selectedDates=[],g.latestSelectedDateObj=void 0,g.currentYear=g._initialDate.getFullYear(),g.currentMonth=g._initialDate.getMonth(),g.showTimeInput=!1,!0===g.config.enableTime&&I();g.redraw(),e&&ue("onChange")},g.close=function(){g.isOpen=!1,g.isMobile||(void 0!==g.calendarContainer&&g.calendarContainer.classList.remove("open"),void 0!==g._input&&g._input.classList.remove("active"));ue("onClose")},g._createElement=d,g.destroy=function(){void 0!==g.config&&ue("onDestroy");for(var e=g._handlers.length;e--;){var t=g._handlers[e];t.element.removeEventListener(t.event,t.handler,t.options)}if(g._handlers=[],g.mobileInput)g.mobileInput.parentNode&&g.mobileInput.parentNode.removeChild(g.mobileInput),g.mobileInput=void 0;else if(g.calendarContainer&&g.calendarContainer.parentNode)if(g.config.static&&g.calendarContainer.parentNode){var n=g.calendarContainer.parentNode;if(n.lastChild&&n.removeChild(n.lastChild),n.parentNode){for(;n.firstChild;)n.parentNode.insertBefore(n.firstChild,n);n.parentNode.removeChild(n)}}else g.calendarContainer.parentNode.removeChild(g.calendarContainer);g.altInput&&(g.input.type="text",g.altInput.parentNode&&g.altInput.parentNode.removeChild(g.altInput),delete g.altInput);g.input&&(g.input.type=g.input._type,g.input.classList.remove("flatpickr-input"),g.input.removeAttribute("readonly"),g.input.value="");["_showTimeInput","latestSelectedDateObj","_hideNextMonthArrow","_hidePrevMonthArrow","__hideNextMonthArrow","__hidePrevMonthArrow","isMobile","isOpen","selectedDateElem","minDateHasTime","maxDateHasTime","days","daysContainer","_input","_positionElement","innerContainer","rContainer","monthNav","todayDateElem","calendarContainer","weekdayContainer","prevMonthNav","nextMonthNav","currentMonthElement","currentYearElement","navigationCurrentMonth","selectedDateElem","config"].forEach(function(e){try{delete g[e]}catch(e){}})},g.isEnabled=Z,g.jumpToDate=P,g.open=function(e,t){void 0===t&&(t=g._positionElement);if(!0===g.isMobile)return e&&(e.preventDefault(),e.target&&e.target.blur()),void 0!==g.mobileInput&&(g.mobileInput.focus(),g.mobileInput.click()),void ue("onOpen");if(g._input.disabled||g.config.inline)return;var n=g.isOpen;g.isOpen=!0,n||(g.calendarContainer.classList.add("open"),g._input.classList.add("active"),ue("onOpen"),ie(t),g.calendarContainer.focus(),!1===g.config.noCalendar&&W(void 0,0));!0===g.config.enableTime&&!0===g.config.noCalendar&&(0===g.selectedDates.length&&(g.setDate(void 0!==g.config.minDate?new Date(g.config.minDate.getTime()):new Date,!1),I(),he()),!1!==g.config.allowInput||void 0!==e&&g.timeContainer.contains(e.relatedTarget)||setTimeout(function(){return g.hourElement.select()},50))},g.redraw=oe,g.set=function(e,n){null!==e&&"object"==typeof e?Object.assign(g.config,e):(g.config[e]=n,void 0!==ce[e]?ce[e].forEach(function(e){return e()}):t.indexOf(e)>-1&&(g.config[e]=l(n)));g.redraw(),P(),he(!1)},g.setDate=function(e,t,n){void 0===t&&(t=!1);void 0===n&&(n=g.config.dateFormat);if(0!==e&&!e||e instanceof Array&&0===e.length)return g.clear(t);de(e,n),g.showTimeInput=g.selectedDates.length>0,g.latestSelectedDateObj=g.selectedDates[0],g.redraw(),P(),k(),he(t),t&&ue("onChange")},g.toggle=function(e){if(!0===g.isOpen)return g.close();g.open(e)};var ce={locale:[ae,q],showMonths:[J,M,U]};function de(e,t){var n=[];if(e instanceof Array)n=e.map(function(e){return g.parseDate(e,t)});else if(e instanceof Date||"number"==typeof e)n=[g.parseDate(e,t)];else if("string"==typeof e)switch(g.config.mode){case"single":case"time":n=[g.parseDate(e,t)];break;case"multiple":n=e.split(g.config.conjunction).map(function(e){return g.parseDate(e,t)});break;case"range":n=e.split(g.l10n.rangeSeparator).map(function(e){return g.parseDate(e,t)})}else g.config.errorHandler(new Error("Invalid date supplied: "+JSON.stringify(e)));g.selectedDates=n.filter(function(e){return e instanceof Date&&Z(e,!1)}),"range"===g.config.mode&&g.selectedDates.sort(function(e,t){return e.getTime()-t.getTime()})}function se(e){return e.slice().map(function(e){return"string"==typeof e||"number"==typeof e||e instanceof Date?g.parseDate(e,void 0,!0):e&&"object"==typeof e&&e.from&&e.to?{from:g.parseDate(e.from,void 0),to:g.parseDate(e.to,void 0)}:e}).filter(function(e){return e})}function ue(e,t){if(void 0!==g.config){var n=g.config[e];if(void 0!==n&&n.length>0)for(var a=0;n[a]&&a<n.length;a++)n[a](g.selectedDates,g.input.value,g,t);"onChange"===e&&(g.input.dispatchEvent(fe("change")),g.input.dispatchEvent(fe("input")))}}function fe(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}function me(e){for(var t=0;t<g.selectedDates.length;t++)if(0===w(g.selectedDates[t],e))return""+t;return!1}function ge(){g.config.noCalendar||g.isMobile||!g.monthNav||(g.yearElements.forEach(function(e,t){var n=new Date(g.currentYear,g.currentMonth,1);n.setMonth(g.currentMonth+t),g.monthElements[t].textContent=m(n.getMonth(),g.config.shorthandCurrentMonth,g.l10n)+" ",e.value=n.getFullYear().toString()}),g._hidePrevMonthArrow=void 0!==g.config.minDate&&(g.currentYear===g.config.minDate.getFullYear()?g.currentMonth<=g.config.minDate.getMonth():g.currentYear<g.config.minDate.getFullYear()),g._hideNextMonthArrow=void 0!==g.config.maxDate&&(g.currentYear===g.config.maxDate.getFullYear()?g.currentMonth+1>g.config.maxDate.getMonth():g.currentYear>g.config.maxDate.getFullYear()))}function pe(e){return g.selectedDates.map(function(t){return g.formatDate(t,e)}).filter(function(e,t,n){return"range"!==g.config.mode||g.config.enableTime||n.indexOf(e)===t}).join("range"!==g.config.mode?g.config.conjunction:g.l10n.rangeSeparator)}function he(e){if(void 0===e&&(e=!0),0===g.selectedDates.length)return g.clear(e);void 0!==g.mobileInput&&g.mobileFormatStr&&(g.mobileInput.value=void 0!==g.latestSelectedDateObj?g.formatDate(g.latestSelectedDateObj,g.mobileFormatStr):""),g.input.value=pe(g.config.dateFormat),void 0!==g.altInput&&(g.altInput.value=pe(g.config.altFormat)),!1!==e&&ue("onValueUpdate")}function ve(e){e.preventDefault();var t=g.prevMonthNav.contains(e.target),n=g.nextMonthNav.contains(e.target);t||n?$(t?-1:1):g.yearElements.indexOf(e.target)>=0?e.target.select():e.target.classList.contains("arrowUp")?g.changeYear(g.currentYear+1):e.target.classList.contains("arrowDown")&&g.changeYear(g.currentYear-1)}return function(){g.element=g.input=n,g.isOpen=!1,function(){var a=["wrap","weekNumbers","allowInput","clickOpens","time_24hr","enableTime","noCalendar","altInput","shorthandCurrentMonth","inline","static","enableSeconds","disableMobile"],i=e({},f,JSON.parse(JSON.stringify(n.dataset||{}))),o={};g.config.parseDate=i.parseDate,g.config.formatDate=i.formatDate,Object.defineProperty(g.config,"enable",{get:function(){return g.config._enable},set:function(e){g.config._enable=se(e)}}),Object.defineProperty(g.config,"disable",{get:function(){return g.config._disable},set:function(e){g.config._disable=se(e)}});var r="time"===i.mode;i.dateFormat||!i.enableTime&&!r||(o.dateFormat=i.noCalendar||r?"H:i"+(i.enableSeconds?":S":""):E.defaultConfig.dateFormat+" H:i"+(i.enableSeconds?":S":"")),i.altInput&&(i.enableTime||r)&&!i.altFormat&&(o.altFormat=i.noCalendar||r?"h:i"+(i.enableSeconds?":S K":" K"):E.defaultConfig.altFormat+" h:i"+(i.enableSeconds?":S":"")+" K"),Object.defineProperty(g.config,"minDate",{get:function(){return g.config._minDate},set:ne("min")}),Object.defineProperty(g.config,"maxDate",{get:function(){return g.config._maxDate},set:ne("max")});var c=function(e){return function(t){g.config["min"===e?"_minTime":"_maxTime"]=g.parseDate(t,"H:i")}};Object.defineProperty(g.config,"minTime",{get:function(){return g.config._minTime},set:c("min")}),Object.defineProperty(g.config,"maxTime",{get:function(){return g.config._maxTime},set:c("max")}),"time"===i.mode&&(g.config.noCalendar=!0,g.config.enableTime=!0),Object.assign(g.config,o,i);for(var d=0;d<a.length;d++)g.config[a[d]]=!0===g.config[a[d]]||"true"===g.config[a[d]];t.filter(function(e){return void 0!==g.config[e]}).forEach(function(e){g.config[e]=l(g.config[e]||[]).map(h)}),g.isMobile=!g.config.disableMobile&&!g.config.inline&&"single"===g.config.mode&&!g.config.disable.length&&!g.config.enable.length&&!g.config.weekNumbers&&/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);for(var d=0;d<g.config.plugins.length;d++){var s=g.config.plugins[d](g)||{};for(var u in s)t.indexOf(u)>-1?g.config[u]=l(s[u]).map(h).concat(g.config[u]):void 0===i[u]&&(g.config[u]=s[u])}ue("onParseConfig")}(),ae(),g.input=g.config.wrap?n.querySelector("[data-input]"):n,g.input?(g.input._type=g.input.type,g.input.type="text",g.input.classList.add("flatpickr-input"),g._input=g.input,g.config.altInput&&(g.altInput=d(g.input.nodeName,g.input.className+" "+g.config.altInputClass),g._input=g.altInput,g.altInput.placeholder=g.input.placeholder,g.altInput.disabled=g.input.disabled,g.altInput.required=g.input.required,g.altInput.tabIndex=g.input.tabIndex,g.altInput.type="text",g.input.setAttribute("type","hidden"),!g.config.static&&g.input.parentNode&&g.input.parentNode.insertBefore(g.altInput,g.input.nextSibling)),g.config.allowInput||g._input.setAttribute("readonly","readonly"),g._positionElement=g.config.positionElement||g._input):g.config.errorHandler(new Error("Invalid input element specified")),function(){g.selectedDates=[],g.now=g.parseDate(g.config.now)||new Date;var e=g.config.defaultDate||("INPUT"!==g.input.nodeName&&"TEXTAREA"!==g.input.nodeName||!g.input.placeholder||g.input.value!==g.input.placeholder?g.input.value:null);e&&de(e,g.config.dateFormat),g._initialDate=g.selectedDates.length>0?g.selectedDates[0]:g.config.minDate&&g.config.minDate.getTime()>g.now.getTime()?g.config.minDate:g.config.maxDate&&g.config.maxDate.getTime()<g.now.getTime()?g.config.maxDate:g.now,g.currentYear=g._initialDate.getFullYear(),g.currentMonth=g._initialDate.getMonth(),g.selectedDates.length>0&&(g.latestSelectedDateObj=g.selectedDates[0]),void 0!==g.config.minTime&&(g.config.minTime=g.parseDate(g.config.minTime,"H:i")),void 0!==g.config.maxTime&&(g.config.maxTime=g.parseDate(g.config.maxTime,"H:i")),g.minDateHasTime=!!g.config.minDate&&(g.config.minDate.getHours()>0||g.config.minDate.getMinutes()>0||g.config.minDate.getSeconds()>0),g.maxDateHasTime=!!g.config.maxDate&&(g.config.maxDate.getHours()>0||g.config.maxDate.getMinutes()>0||g.config.maxDate.getSeconds()>0),Object.defineProperty(g,"showTimeInput",{get:function(){return g._showTimeInput},set:function(e){g._showTimeInput=e,g.calendarContainer&&c(g.calendarContainer,"showTimeInput",e),g.isOpen&&ie()}})}(),g.utils={getDaysInMonth:function(e,t){return void 0===e&&(e=g.currentMonth),void 0===t&&(t=g.currentYear),1===e&&(t%4==0&&t%100!=0||t%400==0)?29:g.l10n.daysInMonth[e]}},g.isMobile||function(){var e=window.document.createDocumentFragment();if(g.calendarContainer=d("div","flatpickr-calendar"),g.calendarContainer.tabIndex=-1,!g.config.noCalendar){if(e.appendChild((g.monthNav=d("div","flatpickr-months"),g.yearElements=[],g.monthElements=[],g.prevMonthNav=d("span","flatpickr-prev-month"),g.prevMonthNav.innerHTML=g.config.prevArrow,g.nextMonthNav=d("span","flatpickr-next-month"),g.nextMonthNav.innerHTML=g.config.nextArrow,J(),Object.defineProperty(g,"_hidePrevMonthArrow",{get:function(){return g.__hidePrevMonthArrow},set:function(e){g.__hidePrevMonthArrow!==e&&(c(g.prevMonthNav,"disabled",e),g.__hidePrevMonthArrow=e)}}),Object.defineProperty(g,"_hideNextMonthArrow",{get:function(){return g.__hideNextMonthArrow},set:function(e){g.__hideNextMonthArrow!==e&&(c(g.nextMonthNav,"disabled",e),g.__hideNextMonthArrow=e)}}),g.currentYearElement=g.yearElements[0],ge(),g.monthNav)),g.innerContainer=d("div","flatpickr-innerContainer"),g.config.weekNumbers){var t=function(){g.calendarContainer.classList.add("hasWeeks");var e=d("div","flatpickr-weekwrapper");e.appendChild(d("span","flatpickr-weekday",g.l10n.weekAbbreviation));var t=d("div","flatpickr-weeks");return e.appendChild(t),{weekWrapper:e,weekNumbers:t}}(),n=t.weekWrapper,a=t.weekNumbers;g.innerContainer.appendChild(n),g.weekNumbers=a,g.weekWrapper=n}g.rContainer=d("div","flatpickr-rContainer"),g.rContainer.appendChild(U()),g.daysContainer||(g.daysContainer=d("div","flatpickr-days"),g.daysContainer.tabIndex=-1),B(),g.rContainer.appendChild(g.daysContainer),g.innerContainer.appendChild(g.rContainer),e.appendChild(g.innerContainer)}g.config.enableTime&&e.appendChild(function(){g.calendarContainer.classList.add("hasTime"),g.config.noCalendar&&g.calendarContainer.classList.add("noCalendar"),g.timeContainer=d("div","flatpickr-time"),g.timeContainer.tabIndex=-1;var e=d("span","flatpickr-time-separator",":"),t=u("flatpickr-hour");g.hourElement=t.getElementsByTagName("input")[0];var n=u("flatpickr-minute");if(g.minuteElement=n.getElementsByTagName("input")[0],g.hourElement.tabIndex=g.minuteElement.tabIndex=-1,g.hourElement.value=i(g.latestSelectedDateObj?g.latestSelectedDateObj.getHours():g.config.time_24hr?g.config.defaultHour:function(e){switch(e%24){case 0:case 12:return 12;default:return e%12}}(g.config.defaultHour)),g.minuteElement.value=i(g.latestSelectedDateObj?g.latestSelectedDateObj.getMinutes():g.config.defaultMinute),g.hourElement.setAttribute("data-step",g.config.hourIncrement.toString()),g.minuteElement.setAttribute("data-step",g.config.minuteIncrement.toString()),g.hourElement.setAttribute("data-min",g.config.time_24hr?"0":"1"),g.hourElement.setAttribute("data-max",g.config.time_24hr?"23":"12"),g.minuteElement.setAttribute("data-min","0"),g.minuteElement.setAttribute("data-max","59"),g.timeContainer.appendChild(t),g.timeContainer.appendChild(e),g.timeContainer.appendChild(n),g.config.time_24hr&&g.timeContainer.classList.add("time24hr"),g.config.enableSeconds){g.timeContainer.classList.add("hasSeconds");var a=u("flatpickr-second");g.secondElement=a.getElementsByTagName("input")[0],g.secondElement.value=i(g.latestSelectedDateObj?g.latestSelectedDateObj.getSeconds():g.config.defaultSeconds),g.secondElement.setAttribute("data-step",g.minuteElement.getAttribute("data-step")),g.secondElement.setAttribute("data-min",g.minuteElement.getAttribute("data-min")),g.secondElement.setAttribute("data-max",g.minuteElement.getAttribute("data-max")),g.timeContainer.appendChild(d("span","flatpickr-time-separator",":")),g.timeContainer.appendChild(a)}return g.config.time_24hr||(g.amPM=d("span","flatpickr-am-pm",g.l10n.amPM[o((g.latestSelectedDateObj?g.hourElement.value:g.config.defaultHour)>11)]),g.amPM.title=g.l10n.toggleTitle,g.amPM.tabIndex=-1,g.timeContainer.appendChild(g.amPM)),g.timeContainer}()),c(g.calendarContainer,"rangeMode","range"===g.config.mode),c(g.calendarContainer,"animate",!0===g.config.animate),c(g.calendarContainer,"multiMonth",g.config.showMonths>1),g.calendarContainer.appendChild(e);var r=void 0!==g.config.appendTo&&void 0!==g.config.appendTo.nodeType;if((g.config.inline||g.config.static)&&(g.calendarContainer.classList.add(g.config.inline?"inline":"static"),g.config.inline&&(!r&&g.element.parentNode?g.element.parentNode.insertBefore(g.calendarContainer,g._input.nextSibling):void 0!==g.config.appendTo&&g.config.appendTo.appendChild(g.calendarContainer)),g.config.static)){var l=d("div","flatpickr-wrapper");g.element.parentNode&&g.element.parentNode.insertBefore(l,g.element),l.appendChild(g.element),g.altInput&&l.appendChild(g.altInput),l.appendChild(g.calendarContainer)}g.config.static||g.config.inline||(void 0!==g.config.appendTo?g.config.appendTo:window.document.body).appendChild(g.calendarContainer)}(),function(){if(g.config.wrap&&["open","close","toggle","clear"].forEach(function(e){Array.prototype.forEach.call(g.element.querySelectorAll("[data-"+e+"]"),function(t){return _(t,"click",g[e])})}),g.isMobile)!function(){var e=g.config.enableTime?g.config.noCalendar?"time":"datetime-local":"date";g.mobileInput=d("input",g.input.className+" flatpickr-mobile"),g.mobileInput.step=g.input.getAttribute("step")||"any",g.mobileInput.tabIndex=1,g.mobileInput.type=e,g.mobileInput.disabled=g.input.disabled,g.mobileInput.required=g.input.required,g.mobileInput.placeholder=g.input.placeholder,g.mobileFormatStr="datetime-local"===e?"Y-m-d\\TH:i:S":"date"===e?"Y-m-d":"H:i:S",g.selectedDates.length>0&&(g.mobileInput.defaultValue=g.mobileInput.value=g.formatDate(g.selectedDates[0],g.mobileFormatStr)),g.config.minDate&&(g.mobileInput.min=g.formatDate(g.config.minDate,"Y-m-d")),g.config.maxDate&&(g.mobileInput.max=g.formatDate(g.config.maxDate,"Y-m-d")),g.input.type="hidden",void 0!==g.altInput&&(g.altInput.type="hidden");try{g.input.parentNode&&g.input.parentNode.insertBefore(g.mobileInput,g.input.nextSibling)}catch(e){}_(g.mobileInput,"change",function(e){g.setDate(e.target.value,!1,g.mobileFormatStr),ue("onChange"),ue("onClose")})}();else{var e=r(te,50);g._debouncedChange=r(F,y),g.daysContainer&&!/iPhone|iPad|iPod/i.test(navigator.userAgent)&&_(g.daysContainer,"mouseover",function(e){"range"===g.config.mode&&ee(e.target)}),_(window.document.body,"keydown",X),g.config.static||_(g._input,"keydown",X),g.config.inline||g.config.static||_(window,"resize",e),void 0!==window.ontouchstart?_(window.document,"click",G):_(window.document,"mousedown",N(G)),_(window.document,"focus",G,{capture:!0}),!0===g.config.clickOpens&&(_(g._input,"focus",g.open),_(g._input,"mousedown",N(g.open))),void 0!==g.daysContainer&&(_(g.monthNav,"mousedown",N(ve)),_(g.monthNav,["keyup","increment"],S),_(g.daysContainer,"mousedown",N(le))),void 0!==g.timeContainer&&void 0!==g.minuteElement&&void 0!==g.hourElement&&(_(g.timeContainer,["increment"],x),_(g.timeContainer,"blur",x,{capture:!0}),_(g.timeContainer,"mousedown",N(A)),_([g.hourElement,g.minuteElement],["focus","click"],function(e){return e.target.select()}),void 0!==g.secondElement&&_(g.secondElement,"focus",function(){return g.secondElement&&g.secondElement.select()}),void 0!==g.amPM&&_(g.amPM,"mousedown",N(function(e){x(e),F()})))}}(),(g.selectedDates.length||g.config.noCalendar)&&(g.config.enableTime&&k(g.config.noCalendar?g.latestSelectedDateObj||g.config.minDate:void 0),he(!1)),M(),g.showTimeInput=g.selectedDates.length>0||g.config.noCalendar;var a=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);!g.isMobile&&a&&ie(),ue("onReady")}(),g}function x(e,t){if(0===e.length)return[];for(var n=Array.from(e).filter(function(e){return e instanceof HTMLElement}),a=[],i=0;i<n.length;i++){var o=n[i];try{if(null!==o.getAttribute("data-fp-omit"))continue;void 0!==o._flatpickr&&(o._flatpickr.destroy(),o._flatpickr=void 0),o._flatpickr=M(o,t||{}),a.push(o._flatpickr)}catch(e){console.error(e)}}return 1===a.length?a[0]:a}"undefined"!=typeof HTMLElement&&(HTMLCollection.prototype.flatpickr=NodeList.prototype.flatpickr=function(e){return x(this,e)},HTMLElement.prototype.flatpickr=function(e){return x([this],e)});var E=function(e,t){return"string"==typeof e?x(window.document.querySelectorAll(e),t):e instanceof Node?x([e],t):x(e,t)};return E.defaultConfig=n,E.l10ns={en:e({},a),default:e({},a)},E.localize=function(t){E.l10ns.default=e({},E.l10ns.default,t)},E.setDefaults=function(t){E.defaultConfig=e({},E.defaultConfig,t)},E.parseDate=D({}),E.formatDate=v({}),E.compareDates=w,"undefined"!=typeof jQuery&&(jQuery.fn.flatpickr=function(e){return x(this,e)}),Date.prototype.fp_incr=function(e){return new Date(this.getFullYear(),this.getMonth(),this.getDate()+("string"==typeof e?parseInt(e,10):e))},"undefined"!=typeof window&&(window.flatpickr=E),E});

                            if(this._flatpickr) {
                                this._flatpickr("#sqzly_field_" + modalSettings.fields[fieldIndex].id, datePickerSettings);
                            }
                        }
                        catch(err) {
                            console.error('SQZLY: failed to load flatpickr');
                        }
                    }
                }
            }
        }
    }

    /**
     *
     * @param {Document} element
     * @param personalizationId
     * @param variantId
     * @param variantRevision
     * @param personalizationId
     */
    bindAllClickElements(element, personalizationId, variantId, variantRevision) {
        var nodes = element.querySelectorAll('a.sqzl-click');
        Array.prototype.forEach.call(nodes, function (node) {
            if(!node.getAttribute('data-sqzl-personalization-id')) {
                node.setAttribute('data-sqzl-personalization-id', personalizationId);
                node.setAttribute('data-sqzl-variant-id', variantId);
                node.setAttribute('data-sqzl-variant-revision', variantRevision);

                var ctaNewWindow = node.getAttribute('target') !== null && node.getAttribute('target') === '_blank';

                if(!node.hasAttribute('data-sqzl-new-window')) {
                    node.setAttribute('data-sqzl-new-window', ctaNewWindow);
                }
            }
        });
    }

    /**
     *
     * @param personalizationId
     * @param variantId
     * @param variantRevision
     * @return {boolean} True if no errors found, false if errors found
     */
    feedbackFormSubmit(personalizationId, variantId, variantRevision) {
        var data = {};
        var error = false;
        var consentsGiven = [];
        var personalizationElt = '#' + this.getVariantElementId(personalizationId, variantId, variantRevision);

        var checkboxFields = this._document.querySelectorAll(personalizationElt + ' .sqzly-checkbox');
        for(let i = 0; i < checkboxFields.length; i++) {
            if (checkboxFields[i].getAttribute('data-field-id') === 'newsletter') {
                if (
                    !checkboxFields[i].checked &&
                    (
                        checkboxFields[i].classList.contains('sqzly-required')
                        ||
                        (
                            !checkboxFields[i].classList.contains('sqzly-required') &&
                            !checkboxFields[i].classList.contains('sqzly-not-required')
                        )
                    )
                ) {
                    //show error
                    checkboxFields[i].parentNode.classList.add('sqzly-checkbox-error');
                    error = true;
                } else if (checkboxFields[i].checked) {
                    checkboxFields[i].parentNode.classList.remove('sqzly-checkbox-error');
                    data.newsletter = 'yes';
                    consentsGiven.push('newsletter');
                }
            } else {
                data[checkboxFields[i].getAttribute('data-field-id')] = checkboxFields[i].checked ? checkboxFields[i].getAttribute('data-value-checked') : checkboxFields[i].getAttribute('data-value-unchecked');
            }
            if(
                checkboxFields[i].getAttribute('data-field-id') === 'marketing' ||
                checkboxFields[i].getAttribute('data-field-id') === 'service'
            ) {
                if(
                    !checkboxFields[i].checked &&
                    (
                        checkboxFields[i].classList.contains('sqzly-required')
                        ||
                        (
                            !checkboxFields[i].classList.contains('sqzly-required') &&
                            !checkboxFields[i].classList.contains('sqzly-not-required')
                        )
                    )
                ) {
                    //show error
                    checkboxFields[i].parentNode.classList.add('sqzly-checkbox-error');
                    error = true;
                }
                else if(checkboxFields[i].checked) {
                    checkboxFields[i].parentNode.classList.remove('sqzly-checkbox-error');
                    consentsGiven.push(checkboxFields[i].getAttribute('data-field-id'));
                }
            }
        }

        var genderFields = this._document.querySelectorAll(personalizationElt + ' .sqzly-gender');
        for(let i = 0; i < genderFields.length; i++) {
            data.gender = genderFields[i].value;
        }

        var textFields = this._document.querySelectorAll(personalizationElt + ' .sqzly-textfield');
        for(let i = 0; i < textFields.length; i++) {
            if (
                !textFields[i].value &&
                (
                    textFields[i].classList.contains('sqzly-required')
                    ||
                    (
                        !textFields[i].classList.contains('sqzly-required') &&
                        !textFields[i].classList.contains('sqzly-not-required')
                    )
                )
            ) {
                textFields[i].classList.add('sqzly-error');
                error = true;
            } else {
                data[textFields[i].getAttribute('data-field-id')] = textFields[i].value;
                textFields[i].classList.remove('sqzly-error');
            }
        }

        var dateFields = this._document.querySelectorAll(personalizationElt + ' .sqzly-datepicker');
        for(let i = 0; i < dateFields.length; i++) {
            if (dateFields[i].getAttribute('data-field-id')) {
                if (
                    !dateFields[i].value &&
                    (
                        dateFields[i].classList.contains('sqzly-required')
                        ||
                        (
                            !dateFields[i].classList.contains('sqzly-required') &&
                            !dateFields[i].classList.contains('sqzly-not-required')
                        )
                    )
                ) {
                    dateFields[i].classList.add('sqzly-error');
                    error = true;
                } else {
                    data[dateFields[i].getAttribute('data-field-id')] = dateFields[i].value;
                    dateFields[i].classList.remove('sqzly-error');
                }
            }
        }

        var emailFields = this._document.querySelectorAll(personalizationElt + ' .sqzly-emailfield');
        for(let i = 0; i < emailFields.length; i++) {
            if (
                (
                    emailFields[i].value.length === 0 &&
                    (
                        emailFields[i].classList.contains('sqzly-required')
                        ||
                        (
                            !emailFields[i].classList.contains('sqzly-required') &&
                            !emailFields[i].classList.contains('sqzly-not-required')
                        )
                    )
                )
                || (emailFields[i].value.length > 0 && !emailFields[i].checkValidity())
            ) {
                emailFields[i].classList.add('sqzly-error');
                error = true;
            } else {
                data[emailFields[i].getAttribute('data-field-id')] = emailFields[i].value;
                emailFields[i].classList.remove('sqzly-error');
            }
        }

        var hiddenFields = this._document.querySelectorAll(personalizationElt + ' .sqzly-hiddenfield');
        for(let i = 0; i < hiddenFields.length; i++) {
            data[hiddenFields[i].getAttribute('data-field-id')] = hiddenFields[i].value;
        }

        if(!error) {
            if(
                this._triggerEvents.hasOwnProperty(personalizationId) &&
                this._triggerEvents[personalizationId].hasOwnProperty('products')
            ) {
                data.products = this._triggerEvents[personalizationId].products;
            }

            this.fireClickEvent(personalizationId, variantId, data);

            if(consentsGiven.length > 0) {
                this.sendToPixel('emailoptin', personalizationId, variantId, data);
            }

            this._document.querySelector(personalizationElt + ' .sqzly-modal-content').classList.add('sqzly-collapse');
            this._document.querySelector(personalizationElt + ' .sqzly-thankyou').classList.add('sqzly-in');
        }

        return !error;
    }

    handleInitPersonalization(event, data) {
        var permissionsFromCookie = sqzlCommon.readConsentCookie();
        if(
            !sqzlCommon.hasConsentManagementEnabled() ||
            (sqzlCommon.hasConsentManagementEnabled() && permissionsFromCookie !== null && sqzlCommon.hasAnalyticsConsent(permissionsFromCookie))
        ) {
            var cookie = sqzlCommon.readCookie(this._settings.mainCookieName, true, this._document, this._localStorage);

            if(cookie === 'null' || !cookie || cookie === '') {
                cookie = sqzlCommon.uniqid('sqzl');
                sqzlCommon.createCookie(this._settings.mainCookieName, cookie, 10957, true, this._document, this._localStorage);
            }
        }
        else if(sqzlCommon.hasConsentManagementEnabled() && permissionsFromCookie !== null && !sqzlCommon.hasAnalyticsConsent(permissionsFromCookie)) {
            cookie = 'noconsent'
        }
        else {
            cookie = '';
        }

        if(cookie !== '') {
            var extraArguments = [];

            extraArguments.push('c=' + cookie);
            extraArguments.push('u=' + encodeURIComponent(this._window.location.href));
            extraArguments.push('nP=' + this._notificationPermission);

            if(this._settings.isTravel === true) {
                var amountNights = this._localStorage.getItem('amount_nights');
                var checkinDate = this._localStorage.getItem('checkin_date');

                if(typeof amountNights !== 'undefined' && amountNights) {
                    extraArguments.push('an=' + amountNights);
                }

                if(typeof checkinDate !== 'undefined' && checkinDate) {
                    extraArguments.push('cd=' + checkinDate);
                }
            }
            if(typeof data !== 'undefined') {
                if(data.hasOwnProperty('products') && data.products.length > 0) {
                    var productIds = [];
                    data.products.forEach(function (product) {
                        if (!product.hasOwnProperty('id')) return false;
                        productIds.push(product.id);
                    });

                    extraArguments.push('p=' + encodeURIComponent(productIds.join(',')));
                }

                if(data.hasOwnProperty('event')) {
                    extraArguments.push('e=' + encodeURIComponent(data.event));
                }

                if(data.hasOwnProperty('category_id')) {
                    extraArguments.push('ci=' + encodeURIComponent(data.category_id));
                }
            }

            var debugLevel = sqzlCommon.getDebugLevel();
            if(debugLevel) {
                extraArguments.push('d=' + debugLevel);
            }

            var isMobile = sqzlCommon.isMobileBrowser() ? '1' : '0';
            extraArguments.push('md=' + isMobile);

            extraArguments.push('l=' + this.getLanguage().toUpperCase());

            //add variant views
            var allCounterCookies = this.getAndExtractCounterCookie();
            if(allCounterCookies) {
                extraArguments.push('vc=' + JSON.stringify(allCounterCookies));
            }

            var allDisableCookies = this.getAndExtractDisableCookie();
            if(allDisableCookies) {
                extraArguments.push('dis=' + JSON.stringify(allDisableCookies));
            }

            if(this._window.hasOwnProperty('nunjucksPrecompiled')) {
                extraArguments.push('tpl=' + Object.keys(this._window.nunjucksPrecompiled).join(','));
            }

            var currentDate = new Date();

            extraArguments.push('tOffset=' + currentDate.getTimezoneOffset());
            extraArguments.push('cB=' + currentDate.getTime() + '.' + currentDate.getMilliseconds());

            if(sqzlCommon.getConfigItem('noJSONP', false) && !sqzlCommon.getDebugLevel()) {
                try {
                    extraArguments.push('no_jsonp=true');

                    sqzlCommon.fetchJson(this._dynamicBaseUrl + this._settings.pathPersonalizationSettings + '&' + extraArguments.join('&'),
                        null,
                        null,
                        function (jsonResponse) {
                            if(jsonResponse.length === undefined && jsonResponse.hasOwnProperty('event')) {
                                this.g.sqzl.p.push(jsonResponse);
                            }
                            else {
                                for(let i = 0; i < jsonResponse.length; i++) {
                                    this.g.sqzl.p.push(jsonResponse[i]);
                                }
                            }
                        }.bind(this),
                        function (error) {
                            console.log('Error occurred fetching personalizations!', error)
                        });
                }
                catch(e) {
                    this.g.sqzlCommon.sqzlException(e);
                }
            }
            else {
                // This should trigger an event SetPersonalizations
                this.requireScript(this._document, this._dynamicBaseUrl + this._settings.pathPersonalizationSettings + '&' + extraArguments.join('&'));
            }
        }
    }

    handleSetPersonalizations(event, data) {
        this._loadedPersonalizationIds = []; // reset list

        if(data.hasOwnProperty('personalizationTriggerOnProductEventsFound')) {
            this._settings.personalizationTriggerOnProductEventsFound = data['personalizationTriggerOnProductEventsFound'];
        }

        if(data.hasOwnProperty('_error') && data._error === true) {
            if(this._settings.personalizationTriggerOnProductEventsFound.length > 0) {
                this.setTimerQueuedPersonalization();
                this.triggerPersonalizationsOnPixelEvents();
            }
            this.removeRemainingHiddenElements();
            return false;
        }

        var personalizationTriggered = false;

        for(var key in data) {
            if(!data.hasOwnProperty(key)) continue;

            var personalization = data[key],
                variant = personalization.variant;

            if(key === 'personalizationTriggerOnProductEventsFound') {
                this.removeHiddenElementByVariantId(variant);
                continue;
            }

            variant = this.replaceInViewProduct(variant);

            if(personalization?.name && variant?.name) {
                sqzlCommon.addPersonalizationName(personalization.id, personalization.name);
                sqzlCommon.addVariantName(variant.id, variant.name);
            }

            if(variant.templateSettings.display_type === 'insert') {
                switch (variant.templateSettings.product_amount) {
                    case "1":
                        variant.templateSettings.grid_class = 'sq-col-xs-12';
                        break;
                    case "2":
                        variant.templateSettings.grid_class = 'sq-col-xs-12 sq-col-sm-6';
                        break;
                    case "3":
                    case "6":
                        variant.templateSettings.grid_class = 'sq-col-xs-12 sq-col-sm-4';
                        break;
                    case "4":
                    case "5":
                    default:
                        variant.templateSettings.grid_class = 'sq-col-xs-12 sq-col-sm-3';
                        break;
                }
            }

            this.removeHiddenElementByVariantId(variant);

            var triggerEvent = personalization.settings.trigger_event_event || null;

            if(personalization.settings.trigger_type === 'product') triggerEvent = personalization.settings.trigger_product_event;

            var variables = Object.assign({}, variant.settings, variant.templateSettings, {
                personalizationId: personalization.id,
                variantId: variant.id,
                trigger_type: personalization.settings.trigger_type,
                trigger_delay: personalization.settings.trigger_delay,
                trigger_event_fields: personalization.settings.trigger_event_fields || [],
                trigger_event_event: triggerEvent,
            });

            variables._variantSettings = Object.assign({}, variables); // new style of passing settings

            this._loadedPersonalizationIds.push(personalization.id);
            this.loadTemplateAndTrigger(personalization, variant, variables);
            sqzlCommon.initSlider(variant.templateSettings, personalization.id);
            personalizationTriggered = true;
        }

        if(personalizationTriggered) {
            this.addDocumentListeners.call(this);
        }

        if(this._settings.personalizationTriggerOnProductEventsFound.length > 0) {
            this.setTimerQueuedPersonalization();
            this.triggerPersonalizationsOnPixelEvents();
        }

        this.removeRemainingHiddenElements();
    }

    removeRemainingHiddenElements() {
        if(
            this._window.hasOwnProperty('_sqzlHE') &&
            this._window._sqzlHE !== null
        ) {
            // unhide the rest of elements that aren't used for these personalizations
            for(var hiddenElementKey in this._window._sqzlHE) {
                if(this._window._sqzlHE.hasOwnProperty(hiddenElementKey)) {
                    this._window._sqzlHE[hiddenElementKey].elm.parentNode.removeChild(this._window._sqzlHE[hiddenElementKey].elm);
                    delete this._window._sqzlHE[hiddenElementKey];
                }
            }
        }
    }

    removeHiddenElementByVariantId(variant) {
        // remove from the _sqzlHE object, so the timer doesn't unhide it. We will unhide it later in loadTemplateAndTrigger()
        if(
            this._window.hasOwnProperty('_sqzlHE') &&
            typeof this._window._sqzlHE !== 'undefined' &&
            this._window._sqzlHE !== null &&
            variant && variant.hasOwnProperty('id') &&
            this._window._sqzlHE.hasOwnProperty(variant.id)
        ) {
            delete this._window._sqzlHE[variant.id];
        }
    }

    addDocumentListeners() {
        if(this._documentListenersDone) {
            return false;
        }

        this._document.addEventListener('click', this.handleEventClick.bind(this), false);

        this._documentListenersDone = true;
    }

    handleEventClick(event) {
        event = event || this._window.e;
        var node = typeof event.target.parentNode !== 'undefined' && event.target.parentNode !== null && event.target.parentNode?.tagName.toLowerCase() === 'a'
            ? event.target.parentNode
            : event.target;

        if(!node.classList.contains('sqzl-click') && typeof node.closest !== 'undefined') {
            // if template changed, search for the closest A-node
            var closestANode = node.closest('a');

             // If closest('a') doesn't find anything, go to higher modal and search for the first a.sqzl-click
             // if(!closestANode && node.closest('.sqzly-modal')) {
             //     closestNode = node.closest('.sqzly-modal').querySelector('a.sqzl-click');
             // }

             if(closestANode) {
                 node = closestANode;
             }
         }

        if(node && node.classList.contains('sqzl-click')) {
            var personalizationId = node.getAttribute('data-sqzl-personalization-id');
            var variantId = node.getAttribute('data-sqzl-variant-id') !== 'false' ? node.getAttribute('data-sqzl-variant-id') : 0;
            var variantRevision = node.getAttribute('data-sqzl-variant-revision') || 0;
            var ctaNewWindow = node.getAttribute('data-sqzl-new-window') === 'true'; // do string check, to convert to boolean

            var eventData = {};

            if(node.getAttribute('data-sqzl-product-id')) {
                eventData.product_id = node.getAttribute('data-sqzl-product-id') || 0;
                if(node.getAttribute('data-sqzl-product-name')) {
                    eventData.product_title = node.getAttribute('data-sqzl-product-name');
                }
                if(node.getAttribute('data-sqzl-product-price')) {
                    eventData.product_price = node.getAttribute('data-sqzl-product-price');
                }
                if(node.getAttribute('data-sqzl-product-position')) {
                    eventData.product_position = node.getAttribute('data-sqzl-product-position');
                }
            }

             if (!personalizationId) return;

             var closingModalExpirationDays = this._settings.closingModalExpirationDays;
             if(this._personalizationSettingCloseModalExpirationDays.hasOwnProperty(personalizationId)) {
                 closingModalExpirationDays = this._personalizationSettingCloseModalExpirationDays[personalizationId] / 1440;
             }

             if (node.className.match(/sqzly-(bar|modal|toaster)-close/)) {
                 let modalElt = this._document.getElementById(this.getVariantElementId(personalizationId, variantId, variantRevision));
                 modalElt.parentNode.removeChild(modalElt);
                 this.state.overlayOpen = false;

                 // Below 0 means for now, don't set cookie see ticket
                 if(closingModalExpirationDays >= 0) {
                     sqzlCommon.createCookie(this._settings.disablePersonalizationCookieName + personalizationId, 1, closingModalExpirationDays, false, this._document);
                 }
                 this.fireCloseEvent(personalizationId, variantId, eventData);
             }
             else if(node.className.match(/sqzly-form-submit/)) {
                 var formResult = this.feedbackFormSubmit(personalizationId, variantId, variantRevision);
                 if(formResult && node.className.match(/ignore-disable/) == null) {
                     sqzlCommon.createCookie(this._settings.disablePersonalizationCookieName + personalizationId, 1, closingModalExpirationDays, false, this._document);
                 }
             }
             else {
                 if(typeof node.dataset !== 'undefined' && typeof node.dataset.sqzlyAttributes !== 'undefined') {
                     try {
                         Object.assign(eventData, JSON.parse(node.dataset.sqzlyAttributes));
                     }
                     catch(e) {}
                 }

                 //close overlay on click
                 if (node.className.match(/sqzly-overlay-cta/)) {
                     let modalElt = this._document.getElementById(this.getVariantElementId(personalizationId, variantId, variantRevision));
                     modalElt.parentNode.removeChild(modalElt);
                 }

                 this.handleClick(node.href, event, ctaNewWindow);
                 this.fireClickEvent(personalizationId, variantId, eventData);
             }
         }
     }

    /**
     * Check if this personalization is disabled by cookie/storage
     *
     * @param personalization
     * @param variant
     * @return {boolean}
     */
    disabledPersonalization(personalization, variant) {
        var cookie = sqzlCommon.readCookie(this._settings.disablePersonalizationCookieName + personalization.id, false, _document);
        return cookie !== '' && parseInt(cookie) === 1;
    }

    /**
     * Get scrollLeft and scrollTop, native JS
     * @return {Object}
     */
    getScroll() {
        if (this._window.pageYOffset !== 'undefined') {
            return {scrollLeft: this._window.pageXOffset, scrollTop: this._window.pageYOffset, windowBottom: this._window.pageYOffset + this._window.innerHeight};
        } else {
            var sx, sy, d = this._document,
                r = d.documentElement,
                b = d.body;
            sx = r.scrollLeft || b.scrollLeft || 0;
            sy = r.scrollTop || b.scrollTop || 0;
            return {scrollLeft: sx, scrollTop: sy, windowBottom: sy + this._window.innerHeight};
        }
    }

    /**
     * Returns the height of the body
     *
     * @return {number}
     */
    getBodyHeight() {
        var body = this._document.body;
        var html = this._document.documentElement;

        return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    }

    /**
     * @param {string} cacheKey
     */
    enableSelector(cacheKey) {
        this.requireScript(this._document, this._assetBaseUrl + '/assets/personalization-dom-inspector.js?version=' + cacheKey );
        // @todo We could warn about the URL not matching with the chosen location here as well.
        // Merchants have to switch URL manually in the preview window URL bar.
        // The query selector button in the variant settings blocks selection and shows a warning message if the url does not match with the personalization settings.
        // So for now, not implemented.
    }

    /**
     * @param {function} callback
     */
    enablePreviewCode(callback) {
        this.requireScript(this._document, this._assetBaseUrl + '/assets/personalization-preview.js', callback);
    }

    /**
     * @param {integer} personalizationId
     * @param {integer} variantId
     * @param {object|undefined} additionalData
     */
    fireViewEvent(personalizationId, variantId, additionalData) {
        additionalData = additionalData || {};

        this.sendToPixel('view', personalizationId, variantId, additionalData);
    }

    /**
     * @param {integer} personalizationId
     * @param {integer} variantId
     * @param {object|undefined} additionalData
     */
    fireClickEvent(personalizationId, variantId, additionalData) {
        additionalData = additionalData || {};

        this.sendToPixel('click', personalizationId, variantId, additionalData);
    }

    /**
     * @param {integer} personalizationId
     * @param {integer} variantId
     * @param {object|undefined} additionalData
     */
    fireCloseEvent(personalizationId, variantId, additionalData) {
        additionalData = additionalData || {};

        this.sendToPixel('close', personalizationId, variantId, additionalData);
    }

    handleClick(targetUrl, event, newWindow) {
        newWindow = typeof newWindow !== 'undefined' ? newWindow : false;

        if(newWindow || (this._window.event && this._window.event.ctrlKey) || (event && event.ctrlKey)) {
            //new window
            if(typeof targetUrl !== 'undefined' && targetUrl.length > 0) {
                this._window.open(targetUrl, "_blank");
            }
        }
        else {
            //same window
            if(typeof targetUrl !== 'undefined' && targetUrl.length > 0) {
                this._window.setTimeout(function() {
                    this.navigateToUrl(targetUrl, event)
                }.bind(this), 250);
            }
        }
        if(this._window.event && this._window.event.preventDefault) {
            this._window.event.preventDefault();
        }
        if(event && event.preventDefault) {
            event.preventDefault();
        }
        return false;
    }

    /**
     * Over-writable function used by SPA's to prevent page reload. Do not remove.
     * @param targetUrl
     */
    navigateToUrl(targetUrl) {
        this._document.location.href = targetUrl;
    }

    sendToPixel(type, personalizationId, variantId, additionalData) {
        if(!personalizationId) {
            if(['debug', 'info', 'warning'].indexOf(sqzlCommon.getDebugLevel()) !== -1) {
                console.warn('sqzly: No personalization id for pixel', personalizationId);
            }

            return;
        }

        if(additionalData && additionalData.hasOwnProperty('product_id') && additionalData.product_id.match(/^{{product_id/) !== null) {
            delete additionalData.product_id; // invalid id
        }

        if(additionalData && additionalData.hasOwnProperty('price') && additionalData.price.match(/^{{ currency_sign/) !== null) {
            delete additionalData.price; // invalid price
        }

        var eventName = null;

        switch(type) {
            case 'click':
                eventName = 'PersonalizationClick';
                break;
            case 'view':
                eventName = 'PersonalizationView';
                break;
            case 'close':
                eventName = 'PersonalizationClosed';
                break;
            case 'emailoptin':
                eventName = 'EmailOptIn';
                break;
            default:
                break;
        }

        if(eventName) {
            var eventData = {event: eventName, personalization_id: personalizationId, personalization_variant_id: variantId};

            if(eventName === 'PersonalizationClick') {
                // Required for audience filters
                eventData.personalization_id_click = personalizationId;
                eventData.personalization_variant_id_click = variantId;
                eventData.control_variant = additionalData && additionalData.hasOwnProperty('control_variant') && additionalData.control_variant === true;
            }
            else if(eventName === 'PersonalizationView') {
                // Required for audience filters
                eventData.personalization_id_view = personalizationId;
                eventData.personalization_variant_id_view = variantId;
                eventData.control_variant = additionalData && additionalData.hasOwnProperty('control_variant') && additionalData.control_variant === true;

                //temp add click count so we can debug SQZLY-6704
                var allCounterCookies = this.getAndExtractCounterCookie();
                if(allCounterCookies) {
                    eventData.personalization_viewcounts = JSON.stringify(allCounterCookies);
                }
            }
            else if(eventName === 'PersonalizationClosed') {
                // Required for audience filters
                eventData.personalization_id_closed = personalizationId;
                eventData.personalization_variant_id_closed = variantId;
            }
            else if(eventName === 'EmailOptIn') {
                eventData = {event: eventName};
            }

            if(typeof additionalData !== 'undefined') {
                var sqzlyPixelParams = Object.assign({}, additionalData); // to create a new object and avoid references
                var productData = {};
                for(var key in sqzlyPixelParams) {
                    if(sqzlyPixelParams.hasOwnProperty(key) && key.match(/^product_/)) {
                        productData[key] = sqzlyPixelParams[key];

                        delete sqzlyPixelParams[key];
                    }
                }

                if(Object.keys(productData).length > 0 && productData.hasOwnProperty('product_title') && productData.hasOwnProperty('product_id')) {
                    eventData.products = [];
                    eventData.products.push({
                        id: productData.product_id || 0,
                        name: productData.product_title || '',
                        price: productData.product_price || 0
                    });
                }

                eventData = Object.assign({}, eventData, sqzlyPixelParams);
            }

            this.g._sqzl.push(eventData);

            var dataToPush = {event: 'sqzl_' + eventName, personalization_id: personalizationId, personalization_variant_id: variantId};

            if(typeof additionalData !== 'undefined') {
                if(additionalData?.control_variant === true) {
                    dataToPush.personalization_variant_id = 'control - ' + variantId;
                }
                dataToPush = Object.assign({}, dataToPush, additionalData);
            }

            this.g.dataLayer.push(dataToPush);
        }
    }

    handlePixelEvent(event, data) {
        if(typeof data?.products?.id !== 'undefined' && !Array.isArray(data?.products)) {
            data.products = [data.products];
        }

        if(Array.isArray(data?.products)) {
            data.products.forEach(function(product) {
                if(typeof product?.language !== 'undefined' && product?.language?.length > 0) {
                    this._lastProductEventLanguage = product.language;
                }
            }.bind(this));
        }

        if(data?.language?.length > 0) {
            this._settings.lastEventLanguage = data.language;
        }

        this._handledPixelEvents.push(data);
        this.triggerPersonalizationsOnPixelEvents();
    }

    triggerPersonalizationsOnPixelEvents() {
        if(this._personalizationQueuedForEvents.length === 0) return false;

        this._handledPixelEvents.forEach(function(eventData) {
            for(let key in this._personalizationQueuedForEvents) {
                if(!this._personalizationQueuedForEvents.hasOwnProperty(key)) continue;

                let personalization = this._personalizationQueuedForEvents[key];
                if(!this.isEligibleEvent(personalization, eventData)) continue;

                this._personalizationQueuedForEvents.splice(key, 1);
                if(personalization?.productTriggeredPersonalization === true) {
                    let personalizationData = {
                            event: 'InitPersonalization',
                            data: {
                                products: [],
                                category_id: null,
                                event: eventData.event,
                            }
                        },
                        initPersonalization = false;

                    if(eventData.hasOwnProperty('products') && eventData.products.length > 0) {
                        personalizationData.data.products = eventData.products;
                        initPersonalization = true;
                    }

                    if(eventData.hasOwnProperty('category_id') && eventData.category_id) {
                        personalizationData.data.category_id = eventData.category_id;
                        initPersonalization = true;
                    }

                    if(initPersonalization) {
                        this._queueItems.push(personalizationData);
                    }
                    this.setTimerQueuedPersonalization(); // call timer function, so timeout is extended
                }
                else {
                    personalization.settings = Object.assign({}, personalization.settings, {
                        triggeredByEventCheck: true
                    });
                    // We need to store the event that triggered the personalization
                    this._triggerEvents[personalization.personalization.id] = eventData;

                    if(this.isMultiTriggerPersonalization(personalization.personalization)) {
                        this.handleDelayTriggers(
                            personalization.personalization,
                            personalization.divElement,
                            personalization.settings,
                            personalization.personalization.variant,
                            Math.floor(new Date() / 1000)
                        );
                    }
                    else {
                        this.insertOrReplaceContainerContent(
                            personalization.divElement,
                            personalization.settings,
                            personalization.personalization,
                            personalization.personalization.variant
                        );
                    }
                }
            }
        }.bind(this));
    }

    /**
     * @param {Object} personalization
     * @param {Object} eventData
     * @return {boolean}
     */
    isEligibleEvent(personalization, eventData) {
        let eventName = personalization?.settings?.trigger_event_event;
        if(
            (
                // Only 1 overlay per page load max
                this.state.overlayShown &&
                personalization?.settings?.display_type === 'overlay'
            ) ||
            (
                typeof eventName !== 'undefined' &&
                eventName.toLowerCase() !== eventData.event.toLowerCase()
            )
        ) {
            return false;
        }

        /**
         * @type {object}
         * @typedef ConfigEventField
         * @property {string} type Type of field
         * @property {string} id Id-name of field
         * @property {string} operator Operator
         * @property {string} value Value
         *
         * @param {ConfigEventField[]} configEventFields
         */
        let configEventFields = personalization.settings.trigger_event_fields;
        if(configEventFields.length < 1) return true;

        let productFieldsToFetch = this.getProductFetchFields(configEventFields);
        if(productFieldsToFetch.length > 0) {
            if(!eventData.hasOwnProperty('products')) {
                // Nothing to match on
                return false;
            }
            let skus = [];
            for(let i in eventData.products) {
                if(eventData.products.hasOwnProperty(i)) {
                    skus.push(eventData.products[i].id);
                }
            }

            if(skus.length === 0) {
                // Nothing to match on
                return false;
            }
        }

        let rulesSatisfied = true;
        configEventFields.forEach(function(configField) {
            if(!eventData.hasOwnProperty(configField.id)) {
                rulesSatisfied = false;
                return;
            }

            for(let eventField in eventData) {
                if(!eventData.hasOwnProperty(eventField)) continue;
                if(eventField.toLowerCase() !== configField.id.toLowerCase()) continue;

                if(!this.doesSatisfyRule(eventData[eventField], configField)) {
                    rulesSatisfied = false;
                    return false;
                }
            }
        }.bind(this));

        return rulesSatisfied;
    }

    isMultiTriggerPersonalization(personalization) {
        return personalization?.settings?.hasOwnProperty('trigger_type')
            && personalization?.settings?.trigger_delay?.length > 0
            && personalization.settings.trigger_type !== 'pageload';
    }

    /**
     * Returns an array of al fields that need a xhr request
     *
     * @type {object}
     * @typedef ConfigEventField
     * @property {string} type Type of field
     * @property {string} id Id-name of field
     * @property {string} operator Operator
     * @property {string} value Value
     *
     * @param {ConfigEventField[]} configEventFields
     *
     * @return {array}
     */
    getProductFetchFields(configEventFields) {
        var fields = [];
        configEventFields.forEach(function(configField) {
            if(
                [
                    'inventory',
                    'condition',
                    'availability',
                    'brand'
                ].indexOf(configField.id.toLowerCase()) !== -1
            ) {
                // This is a field of which we need to fetch info to be able to evaluate the trigger
                fields.push(configField.id.toLowerCase());
            }
        });

        return fields;
    }

    /**
     *
     * @param {string|int} eventValue
     * @param {ConfigEventField} configEventField
     * @return {boolean}
     */
    doesSatisfyRule(eventValue, configEventField) {
        switch(configEventField.operator) {
            case 'equals':
            case 'equal':
                if(configEventField.type === 'date') {
                    return (+new Date(eventValue)) === (+new Date(configEventField.value));
                }
                else {
                    return eventValue.toString().toLowerCase() === configEventField.value.toString().toLowerCase();
                }
            case 'not_equals':
            case 'not_equal':
                return eventValue.toString().toLowerCase() !== configEventField.value.toString().toLowerCase();
            case 'contains':
                return eventValue.toString().toLowerCase().indexOf(configEventField.value.toString().toLowerCase()) > -1;
            case 'not_contains':
                return eventValue.toString().toLowerCase().indexOf(configEventField.value.toString().toLowerCase()) === -1;
            case 'greater':
                if(configEventField.type === 'date') {
                    return (+new Date(eventValue)) > (+new Date(configEventField.value));
                }

                return parseFloat(eventValue.toString()) > parseFloat(configEventField.value.toString());
            case 'less':
                if(configEventField.type === 'date') {
                    return (+new Date(eventValue)) < (+new Date(configEventField.value));
                }

                return parseFloat(eventValue.toString()) < parseFloat(configEventField.value.toString());
        }

        return false;
    }

    /**
     *
     * @param {Object} personalization
     * @param {Object} variables
     * @param {Object} variant
     * @param {Array} items
     * @param {String=} productSku
     * @return {null|HTMLDivElement} Null if div element is already created previously
     */
    renderAndInjectElement(personalization, variables, variant, items, productSku) {
        productSku = productSku || '';

        var divElementId = this.getVariantElementId(personalization.id, variant.id, variant.settings.revision, productSku),
            divElement = null,
            originalVariant = variant.settings.hasOwnProperty('original_variant') && variant.settings.original_variant === true,
            globalFields = variant.hasOwnProperty('globalFields') ? variant.globalFields : {},
            filledTemplate = '';

        if(this._document.getElementById(divElementId)) {
           return null;
        }

        if(!originalVariant) {
            variables.divElementId = divElementId;
            variables = this.renderAndReplaceInlineVariables(variables, items);
            variables = Object.assign({}, variables, globalFields);
            // Render string on the spot
            if(sqzlCommon.getConfigItem('noJSONP', false) && personalization.hasOwnProperty('variant') && personalization.variant.hasOwnProperty('template')) {
                filledTemplate = this._njkEnv.renderString(personalization.variant.template, variables);
            }
            else {
                var templateId = this.getTemplateKey(personalization.id, variant.id, variant.settings.revision);
                filledTemplate = this._njkEnv.render(templateId, variables);
            }
        }

        divElement = this._document.createElement('div');
        divElement.id = divElementId;
        divElement.innerHTML = filledTemplate;
        divElement.style.display = 'none';

        var cssClasses = ['sqzly-' + personalization.id];

        if(!originalVariant && variant.hasOwnProperty('id')) {
            cssClasses.push('sqzly-' + personalization.id + '-' + variant.id);
        }

        divElement.className = cssClasses.join(' ');
        this._document.body.appendChild(divElement);

        //disable styles, can only do after inserted :(
        var styleElements = this._document.getElementById(divElementId).getElementsByTagName('style');
        if(styleElements) {
            for(var i = 0; i < styleElements.length; i++) {
                styleElements[i].disabled = true;
            }
        }

        return divElement;
    }

    /**
     *
     * @param {HTMLDivElement} sqzlPersonalization
     * @param {String} querySelector
     * @param {Object} settings
     * @param {boolean} originalVariant
     * @param {boolean|Number} personalizationId
     * @param {boolean|String|Number} variantId
     * @param {boolean|String|Number} variantRevision
     * @return {boolean}
     */
    searchQuerySelectorAndReplaceElements(
        sqzlPersonalization,
        querySelector,
        settings,
        originalVariant,
        personalizationId,
        variantId,
        variantRevision
    ) {
        var elts = this._document.querySelectorAll(querySelector);
        var elementFound = false;

        for (var i = 0; i < elts.length; i++) {
            var elt = elts[i];
            if(elt) {
                var sqzlPersonalizationElt = null;

                // Only clone if more than 1 element found
                sqzlPersonalizationElt = elts.length === 1 ? sqzlPersonalization : sqzlPersonalization.cloneNode(true);
                elementFound = true;

                try {
                    if(settings.insert_location === 'before') {
                        elt.parentNode.insertBefore(sqzlPersonalizationElt, elt);
                    }
                    else if(settings.insert_location === 'behind') {
                        elt.parentNode.insertBefore(sqzlPersonalizationElt, elt.nextSibling);
                    }
                    else if(settings.insert_location === 'replace') {
                        elt.parentNode.replaceChild(sqzlPersonalizationElt, elt);
                    }
                    else {
                        elt.innerHTML = '';
                        elt.appendChild(sqzlPersonalizationElt);
                    }
                }
                catch(e) {
                    if(e?.name === 'HierarchyRequestError') {
                        // For example: "Failed to execute 'replaceChild' on 'Node': The new child element contains the parent."
                        e = 'sqzly: Cannot Replace element contents, Replace element, Insert before element or Insert behind element. ' +
                            'The selected query selector is contained within the personalization body ' +
                            '(personalizationId: ' + personalizationId + ', variantId: ' + variantId + ')';
                    }
                    console.error(e);
                    continue;
                }

                this.enableStyles(sqzlPersonalizationElt);
                sqzlPersonalizationElt.style.display = 'block';

                if(!originalVariant) {
                    this.bindElements(
                        sqzlPersonalizationElt,
                        personalizationId,
                        variantId,
                        variantRevision,
                        typeof settings.elements.button.new_window !== 'undefined' ? settings.elements.button.new_window : false, settings
                    );
                }

                if(personalizationId) {
                    this._settings.triggeredPersonalizations[personalizationId] = true;
                }
            }
        }

        return elementFound;
    }

    removePreviousPersonalizations(event) {
        if(this._personalizationQueuedIfNoProductFoundTimer) {
            clearTimeout(this._personalizationQueuedIfNoProductFoundTimer);
            this._personalizationQueuedIfNoProductFoundTimer = false;
        }

        if(event.hasOwnProperty('removePersonalizations')) {
            if(event.removePersonalizations === false) {
                return; //do not clear anything
            }
            else if(Array.isArray(event.removePersonalizations)) {
                for(var i = 0; i < event.removePersonalizations.length; i++) {

                    var persoElt = this._document.querySelector('.sqzly-' + event.removePersonalizations[i]);
                    if(persoElt) {
                        if (persoElt.parentNode !== null) {
                            persoElt.parentNode.removeChild(persoElt);
                        }
                    }
                    if(this._settings.triggeredPersonalizations.hasOwnProperty(event.removePersonalizations[i])) {
                        delete this._settings.triggeredPersonalizations[event.removePersonalizations[i]];
                    }
                }
            }
        }
        else {

            this._document.querySelectorAll('div.sqzly-personalization, div.sqzly-modal').forEach(function(node) {
                /**
                 * node = .sqzly-personalization
                 * parentNode = #sqzl_div-xx-yy
                 * parentNode.parentNode = <container it's inside, for example body>
                 */
                if(typeof node.id !== 'undefined' && node.id.length > 1 && node.id === 'sqzl_container') {
                    return false; // skip our own container
                }

                if (node.parentNode.parentNode !== null) {
                    node.parentNode.parentNode.removeChild(node.parentNode);
                }
            });
            this._settings.triggeredPersonalizations = {};

        }
        this._personalizationQueuedIfNoProductFound = [];
        this._handledPixelEvents = [];
    }

    enableStyles(element) {
        var styleElements = element.getElementsByTagName('style');
        if(styleElements) {
            for(var i = 0; i < styleElements.length; i++) {
                styleElements[i].disabled = false;
            }
        }

    }

    /**
     * This only read/writes to the one-cookie solution
     *
     * @param {Number} variantId
     * @param {Object} settings
     * @param {Object} personalization
     */
    increaseViewCounter(variantId, settings, personalization) {
        let allCounterCookies = this.getAndExtractCounterCookie(),
            viewCount = 0;

        if(allCounterCookies.hasOwnProperty(variantId)) {
            viewCount = allCounterCookies[variantId].c;
            viewCount = viewCount !== '' ? parseInt(viewCount) : 0;
            viewCount = isNaN(viewCount) ? 0 : viewCount;
        }
        else {
            allCounterCookies[variantId] = {
                c: 0,
                ex: 0
            };
        }

        let frequencyCapPeriod = this._settings.defaultFrequencyCapDays;
        if(sqzlCommon.isDefined(personalization.settings, 'frequency_cap.period_minutes')) {
            var variantFrequencyCapPeriod = parseInt(personalization.settings.frequency_cap.period_minutes);
            if(typeof variantFrequencyCapPeriod === 'number' && variantFrequencyCapPeriod > 0) {
                // Minutes to days
                // We do the conversion to/from minutes to store minutes in the DB.
                // If we ever want a higher resolution than days it'll be easy to change without conversion scripts.
                frequencyCapPeriod = variantFrequencyCapPeriod / 1440;
            }
        }

        allCounterCookies[variantId].c = viewCount + 1;
        allCounterCookies[variantId].ex = Math.round(this.getCurrentTime() / 1000) + (frequencyCapPeriod * 86400);

        this.setCounterCookie(allCounterCookies);
    }

    getCurrentTime() {
        return new Date().getTime();
    }

    /**
     * Gets the one cookie that contains all the counters
     * Remove any expired entries
     *
     * @return {CounterCookie} Always returns an object, if no cookie is found
     */
    getAndExtractCounterCookie() {
        const cookieAllCounters = sqzlCommon.readCookie(this._settings.viewCountCookieName, true, this._document, this._localStorage);
        if(!cookieAllCounters || cookieAllCounters.length === 0) {
            return {};
        }

        try {
            /**
             * @type {CounterCookie[]}
             */
            let allCounters = JSON.parse(cookieAllCounters);
            const currentTimestamp = Math.round(this.getCurrentTime() / 1000);

            for(let variantId in allCounters) {
                const variantCounter = allCounters[variantId];
                if(variantCounter.hasOwnProperty('ex') && variantCounter.ex < currentTimestamp) {
                    // Expired entry
                    delete allCounters[variantId];
                }
            }

            return allCounters;
        }
        catch(err) {
             // Maybe report back with HCE, so we can monitor it?
        }

        return {};
    }

    /**
     * Gets the ids of all disabled personalizations
     */
    getAndExtractDisableCookie() {
        var disabledPersonalizations = [];
        try {
            if(this._document.cookie && this._document.cookie.split(';').length > 0){

                var currentCookies = this._document.cookie.split(';');

                currentCookies.forEach(function(cookieData) {
                    cookieData = cookieData.trim();
                    if(cookieData.match(this._settings.disablePersonalizationCookieName)) {
                        let cookieSplit = cookieData.split('='),
                            cookieName = cookieSplit[0],
                            variantInfo = cookieName.split('_'),
                            variantId = variantInfo[3];
                        disabledPersonalizations.push(variantId);
                    }
                }.bind(this));
            }
        }
        catch(err) {
             // Maybe report back with HCE, so we can monitor it?
        }

        return disabledPersonalizations;
    }

    setCounterCookie(modifiedCounters) {
        var currentCounters = this.getAndExtractCounterCookie();

        var newCookieValue = Object.assign(currentCounters, modifiedCounters);
        sqzlCommon.createCookie(
            this._settings.viewCountCookieName,
            JSON.stringify(newCookieValue),
            this._settings.viewCookieExpirationDays,
            true,
            this._document,
            this._localStorage
        );
    }

    shouldShowCookie() {
        return sqzlCommon.getURLParameter('_sqzl_cookie') === 'true';
    }

    initializeCookieModal() {
        // Create the modal container with styles
        this._sqzlModal = this._document.createElement('div');
        this._sqzlModal.id = "sqzlModal";
        Object.assign(this._sqzlModal.style, {
            display: "none",
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "1000",
            padding: "20px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            width: "300px" // Fixed width for the modal
        });

        // Container for the cookie text
        const cookieDisplayContainer = this._document.createElement('div');
        const cookieValueSpan = this._document.createElement('span');
        cookieValueSpan.id = "sqzlCookieValue";

        cookieDisplayContainer.textContent = "Your Spotler Activate cookie: ";
        cookieDisplayContainer.appendChild(cookieValueSpan);
        Object.assign(cookieDisplayContainer.style, {
            fontSize: "14px",
            marginBottom: "15px",
            color: "#333"
        });

        // Copy button
        const copyButton = this._document.createElement('button');
        copyButton.textContent = "Copy Cookie";
        Object.assign(copyButton.style, {
            padding: "8px 16px",
            backgroundColor: "#007BFF",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",
            marginRight: "20px",
            marginBottom: "10px"
        });
        copyButton.addEventListener('click', () => {
            navigator.clipboard.writeText(cookieValueSpan.textContent);
            // Change background color temporarily when clicked
            copyButton.style.backgroundColor = "#6c757d"; // Gray color
            setTimeout(() => {
                copyButton.style.backgroundColor = "#007BFF"; // Restore original color after 500 milliseconds
            }, 100);
        });

        // Close button
        const closeButton = this._document.createElement('button');
        closeButton.textContent = "Close";
        Object.assign(closeButton.style, {
            padding: "8px 16px",  // Consistent padding with copy button
            backgroundColor: "#ccc",
            color: "black",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "14px",  // Consistent font size with copy button
            marginBottom: "10px"  // Optional: additional margin at the bottom
        });
        closeButton.addEventListener('click', () => {
            this._sqzlModal.style.display = 'none';
        });

        // Button container for better alignment and spacing
        const buttonContainer = this._document.createElement('div');
        Object.assign(buttonContainer.style, {
            display: "flex",
            justifyContent: "space-between"
        });

        // Append buttons to the container instead of the modal directly
        buttonContainer.appendChild(copyButton);
        buttonContainer.appendChild(closeButton);

        // Append all elements to the modal
        this._sqzlModal.appendChild(cookieDisplayContainer);
        this._sqzlModal.appendChild(buttonContainer);
        this._document.body.appendChild(this._sqzlModal);
    }

    showCookieModal() {
        const cookieName = sqzlCommon.getConstants().sqzlMainCookieName;
        const cookieValue = sqzlCommon.readCookie(cookieName);
        const cookieValueSpan = this._document.getElementById('sqzlCookieValue');
        cookieValueSpan.textContent = cookieValue || 'No Spotler Activate cookie found.';
        this._sqzlModal.style.display = 'block';
    }
}